import React from 'react';

const Decor1: React.FC = () => {
  return (
    <g
      className="prefix__map-decor-1 prefix__map-decor"
      transform="translate(85 140)"
    >
      <defs>
        <linearGradient
          id="fda8daaa-1ae8-4e76-9136-26b1ff7dd8cc"
          data-name="grad-109"
          x1="1255.9"
          y1="67.19"
          x2="1339.74"
          y2="67.19"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#005990" />
          <stop offset="0" stopColor="#00598f" />
          <stop offset="0.07" stopColor="#0c4e71" />
          <stop offset="0.14" stopColor="#13475f" />
          <stop offset="0.18" stopColor="#154558" />
          <stop offset="0.4" stopColor="#114151" />
          <stop offset="0.86" stopColor="#0f3f4f" />
        </linearGradient>
        <linearGradient
          id="f476cdfd-d7f1-4299-87df-c32f46c039d2"
          x1="373.57"
          y1="154.56"
          x2="457.42"
          y2="154.56"
          xlinkHref="#fda8daaa-1ae8-4e76-9136-26b1ff7dd8cc"
        />
        <linearGradient
          id="efb1ddfb-8536-47bc-b431-af6dbf9a0bda"
          data-name="grad-28"
          x1="393.46"
          y1="143.71"
          x2="393.98"
          y2="208.84"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.08" stopColor="#f4cb76" />
          <stop offset="1" stopColor="#bf534f" />
        </linearGradient>
        <linearGradient
          id="b5e67398-3e86-4ff0-b343-db421b98d40e"
          x1="389.27"
          y1="164.94"
          x2="389.56"
          y2="200.92"
          xlinkHref="#efb1ddfb-8536-47bc-b431-af6dbf9a0bda"
        />
        <linearGradient
          id="adda5497-7d3e-47bf-a92a-dcdc99530f70"
          x1="393.63"
          y1="173.65"
          x2="392.37"
          y2="220.93"
          xlinkHref="#efb1ddfb-8536-47bc-b431-af6dbf9a0bda"
        />
        <linearGradient
          id="bdc2ae7d-1f23-4c56-913b-09e026725ab7"
          data-name="grad-126"
          x1="1220.5"
          y1="385.58"
          x2="1221.1"
          y2="459.73"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#00ac90" />
          <stop offset="0.09" stopColor="#009e87" />
          <stop offset="0.37" stopColor="#00746c" />
          <stop offset="0.63" stopColor="#005658" />
          <stop offset="0.84" stopColor="#00444c" />
          <stop offset="1" stopColor="#003d48" />
        </linearGradient>
        <linearGradient
          id="f150496c-66cd-49a5-8ef2-235d713cec7b"
          x1="1215.74"
          y1="409.75"
          x2="1216.07"
          y2="450.72"
          xlinkHref="#bdc2ae7d-1f23-4c56-913b-09e026725ab7"
        />
        <linearGradient
          id="fcf0278e-8c2d-46c1-9032-184b21fefdad"
          x1="1220.69"
          y1="419.67"
          x2="1219.25"
          y2="473.5"
          xlinkHref="#bdc2ae7d-1f23-4c56-913b-09e026725ab7"
        />
        <linearGradient
          id="a718b927-7c43-49a9-9d91-c7844ec97086"
          x1="1364.69"
          y1="455.14"
          x2="1365.13"
          y2="510.28"
          xlinkHref="#efb1ddfb-8536-47bc-b431-af6dbf9a0bda"
        />
        <linearGradient
          id="f94341ce-bd70-4379-882a-9ca9d3495050"
          x1="1361.14"
          y1="473.11"
          x2="1361.39"
          y2="503.58"
          xlinkHref="#efb1ddfb-8536-47bc-b431-af6dbf9a0bda"
        />
        <linearGradient
          id="a61eef57-9e30-4c59-867e-3b48aacb4f8b"
          x1="1364.83"
          y1="480.49"
          x2="1363.76"
          y2="520.53"
          xlinkHref="#efb1ddfb-8536-47bc-b431-af6dbf9a0bda"
        />
        <linearGradient
          id="b464a571-a0ce-4c66-b825-a421411fdd99"
          data-name="grad-58"
          x1="1092.3"
          y1="501.2"
          x2="1092.74"
          y2="556.35"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.08" stopColor="#dd15ff" />
          <stop offset="1" stopColor="#5f3e56" />
        </linearGradient>
        <linearGradient
          id="ada7f351-f536-44cd-917d-eb4166ca78cd"
          x1="1088.75"
          y1="519.18"
          x2="1089"
          y2="549.65"
          xlinkHref="#b464a571-a0ce-4c66-b825-a421411fdd99"
        />
        <linearGradient
          id="ed242f3d-b227-4fb1-b306-869862a98d52"
          x1="1092.44"
          y1="526.56"
          x2="1091.37"
          y2="566.59"
          xlinkHref="#b464a571-a0ce-4c66-b825-a421411fdd99"
        />
        <linearGradient
          id="bd3b1006-c459-4b06-a44a-430815498c36"
          x1="1004.16"
          y1="202.83"
          x2="1004.74"
          y2="274.64"
          xlinkHref="#b464a571-a0ce-4c66-b825-a421411fdd99"
        />
        <linearGradient
          id="f4ae110b-58a0-42a5-879d-a99d42ff9314"
          x1="999.54"
          y1="226.24"
          x2="999.86"
          y2="265.91"
          xlinkHref="#b464a571-a0ce-4c66-b825-a421411fdd99"
        />
        <linearGradient
          id="a02c409c-67ce-495b-bda2-817fa245c765"
          x1="1004.34"
          y1="235.85"
          x2="1002.95"
          y2="287.97"
          xlinkHref="#b464a571-a0ce-4c66-b825-a421411fdd99"
        />
        <linearGradient
          id="a5611989-0511-4b55-bed0-0a78d306b3ae"
          x1="432.28"
          y1="363.81"
          x2="485.6"
          y2="363.81"
          xlinkHref="#bdc2ae7d-1f23-4c56-913b-09e026725ab7"
        />
        <linearGradient
          id="b8ca95fb-2faa-4a58-9785-c3c6b820103e"
          x1="457.43"
          y1="305.76"
          x2="457.92"
          y2="365.74"
          xlinkHref="#bdc2ae7d-1f23-4c56-913b-09e026725ab7"
        />
        <linearGradient
          id="a5aae58d-a556-4676-9635-3db154f8013b"
          x1="453.58"
          y1="325.31"
          x2="453.85"
          y2="358.45"
          xlinkHref="#bdc2ae7d-1f23-4c56-913b-09e026725ab7"
        />
        <linearGradient
          id="bdd149c0-a2fc-49bf-a74b-eaca2e88cc67"
          x1="457.59"
          y1="333.34"
          x2="456.43"
          y2="376.87"
          xlinkHref="#bdc2ae7d-1f23-4c56-913b-09e026725ab7"
        />
        <linearGradient
          id="f1308ecb-15ec-4732-9e40-780695c6ff67"
          x1="483.63"
          y1="378.33"
          x2="520.41"
          y2="378.33"
          xlinkHref="#efb1ddfb-8536-47bc-b431-af6dbf9a0bda"
        />
        <linearGradient
          id="f86b4de5-0b49-4021-bf3f-9b566d034893"
          x1="500.98"
          y1="338.29"
          x2="501.31"
          y2="379.66"
          xlinkHref="#efb1ddfb-8536-47bc-b431-af6dbf9a0bda"
        />
        <linearGradient
          id="ba72bb04-1869-4c6e-a78f-0359a4e00738"
          x1="498.32"
          y1="351.78"
          x2="498.51"
          y2="374.63"
          xlinkHref="#efb1ddfb-8536-47bc-b431-af6dbf9a0bda"
        />
        <linearGradient
          id="b3534e58-2a53-4b83-826b-3b0f989bf356"
          x1="501.09"
          y1="357.31"
          x2="500.29"
          y2="387.34"
          xlinkHref="#efb1ddfb-8536-47bc-b431-af6dbf9a0bda"
        />
        <linearGradient
          id="b85782f7-db5d-46e7-b746-d34a16fb7a55"
          x1="404.14"
          y1="388.52"
          x2="440.91"
          y2="388.52"
          xlinkHref="#b464a571-a0ce-4c66-b825-a421411fdd99"
        />
        <linearGradient
          id="aff5729b-f6e3-4ba7-8f18-9de3145c9b3f"
          x1="421.49"
          y1="348.49"
          x2="421.82"
          y2="389.85"
          xlinkHref="#b464a571-a0ce-4c66-b825-a421411fdd99"
        />
        <linearGradient
          id="f3e07513-7a7b-4bc8-924b-027c78fc0c32"
          x1="418.83"
          y1="361.98"
          x2="419.01"
          y2="384.83"
          xlinkHref="#b464a571-a0ce-4c66-b825-a421411fdd99"
        />
        <linearGradient
          id="b25680a3-b9bb-4655-af99-1bb58993928f"
          x1="421.59"
          y1="367.51"
          x2="420.79"
          y2="397.53"
          xlinkHref="#b464a571-a0ce-4c66-b825-a421411fdd99"
        />
        <linearGradient
          id="a7f02a41-3870-4a7a-9e35-7717119f6877"
          x1="1382.29"
          y1="495.44"
          x2="1383.41"
          y2="636.81"
          xlinkHref="#efb1ddfb-8536-47bc-b431-af6dbf9a0bda"
        />
        <linearGradient
          id="aa9c4e56-004b-44bd-a148-c1eb6727bac3"
          x1="1370.98"
          y1="481.3"
          x2="1372.21"
          y2="636.7"
          xlinkHref="#efb1ddfb-8536-47bc-b431-af6dbf9a0bda"
        />
        <linearGradient
          id="a3de26e2-a151-459d-b2b1-039290b7711a"
          x1="1393.59"
          y1="472.11"
          x2="1394.9"
          y2="636.8"
          xlinkHref="#efb1ddfb-8536-47bc-b431-af6dbf9a0bda"
        />
        <linearGradient
          id="a27c7b39-2736-4b1b-a903-13ef1e882e12"
          x1="1359.67"
          y1="464.34"
          x2="1361.04"
          y2="636.47"
          xlinkHref="#efb1ddfb-8536-47bc-b431-af6dbf9a0bda"
        />
        <linearGradient
          id="bfa30389-e8ec-43d6-93a8-96f62b09e5c8"
          x1="1348.36"
          y1="489.08"
          x2="1349.53"
          y2="636.17"
          xlinkHref="#efb1ddfb-8536-47bc-b431-af6dbf9a0bda"
        />
        <linearGradient
          id="effd281a-20b0-46d0-b8d7-f0b246f9e9da"
          x1="1325.75"
          y1="489.08"
          x2="1326.91"
          y2="634.95"
          xlinkHref="#efb1ddfb-8536-47bc-b431-af6dbf9a0bda"
        />
        <linearGradient
          id="ac832ae8-49b1-4ce3-b2d0-33e96cadb890"
          x1="1337.06"
          y1="472.11"
          x2="1338.35"
          y2="635.6"
          xlinkHref="#efb1ddfb-8536-47bc-b431-af6dbf9a0bda"
        />
        <linearGradient
          id="ba856eb3-e8e0-4c41-a5e4-45def4629253"
          x1="1416.21"
          y1="448.79"
          x2="1417.7"
          y2="636.68"
          xlinkHref="#efb1ddfb-8536-47bc-b431-af6dbf9a0bda"
        />
        <linearGradient
          id="b7d05d11-e5fa-48af-830f-12ab8ff71955"
          x1="1393.59"
          y1="438.9"
          x2="1395.15"
          y2="635.35"
          xlinkHref="#efb1ddfb-8536-47bc-b431-af6dbf9a0bda"
        />
        <linearGradient
          id="bab56b5d-0e07-4d06-b792-666361d801e4"
          x1="1359.67"
          y1="438.9"
          x2="1361.23"
          y2="635.35"
          xlinkHref="#efb1ddfb-8536-47bc-b431-af6dbf9a0bda"
        />
        <linearGradient
          id="f28b40f5-c655-47b1-981b-f8b34d5294be"
          x1="1314.44"
          y1="502.5"
          x2="1315.49"
          y2="634.12"
          xlinkHref="#efb1ddfb-8536-47bc-b431-af6dbf9a0bda"
        />
        <linearGradient
          id="f8657fa6-e0d4-41a2-b96b-d715969e2776"
          x1="1404.9"
          y1="495.44"
          x2="1406.02"
          y2="636.76"
          xlinkHref="#efb1ddfb-8536-47bc-b431-af6dbf9a0bda"
        />
        <linearGradient
          id="b71f52cd-d1f2-4949-b43e-e802a3543fe4"
          x1="1270.48"
          y1="527.85"
          x2="1271.34"
          y2="636.06"
          xlinkHref="#efb1ddfb-8536-47bc-b431-af6dbf9a0bda"
        />
        <linearGradient
          id="ad4e2c12-31fc-42bf-b173-285ed5b53183"
          x1="1261.83"
          y1="517.03"
          x2="1262.77"
          y2="635.98"
          xlinkHref="#efb1ddfb-8536-47bc-b431-af6dbf9a0bda"
        />
        <linearGradient
          id="f7f33685-4afb-4778-b168-984702ef330e"
          x1="1279.14"
          y1="510"
          x2="1280.14"
          y2="636.06"
          xlinkHref="#efb1ddfb-8536-47bc-b431-af6dbf9a0bda"
        />
        <linearGradient
          id="f6ccfa80-6d7b-4ed9-9262-350f67911d2b"
          x1="1253.17"
          y1="504.05"
          x2="1254.22"
          y2="635.81"
          xlinkHref="#efb1ddfb-8536-47bc-b431-af6dbf9a0bda"
        />
        <linearGradient
          id="a433ceab-9ce5-4cf7-81ab-72bb9c9b498e"
          x1="1244.52"
          y1="522.98"
          x2="1245.41"
          y2="635.58"
          xlinkHref="#efb1ddfb-8536-47bc-b431-af6dbf9a0bda"
        />
        <linearGradient
          id="ef4e82e5-acbf-4541-9921-d8f98d09728e"
          x1="1227.2"
          y1="522.98"
          x2="1228.09"
          y2="634.64"
          xlinkHref="#efb1ddfb-8536-47bc-b431-af6dbf9a0bda"
        />
        <linearGradient
          id="f4501b39-a116-43df-ab53-3c3bbeb13744"
          x1="1235.86"
          y1="510"
          x2="1236.85"
          y2="635.14"
          xlinkHref="#efb1ddfb-8536-47bc-b431-af6dbf9a0bda"
        />
        <linearGradient
          id="b4c1056e-f7c8-4d05-abe0-e86918a3a86d"
          x1="1296.45"
          y1="492.15"
          x2="1297.59"
          y2="635.97"
          xlinkHref="#efb1ddfb-8536-47bc-b431-af6dbf9a0bda"
        />
        <linearGradient
          id="b65d23e6-4a65-4f20-a00c-6147d1758584"
          x1="1279.14"
          y1="484.57"
          x2="1280.33"
          y2="634.95"
          xlinkHref="#efb1ddfb-8536-47bc-b431-af6dbf9a0bda"
        />
        <linearGradient
          id="b9e2654c-2061-45ad-80ca-2fa3e01ed5f1"
          x1="1253.17"
          y1="484.57"
          x2="1254.36"
          y2="634.95"
          xlinkHref="#efb1ddfb-8536-47bc-b431-af6dbf9a0bda"
        />
        <linearGradient
          id="ed32a6d6-a8cd-48d5-a958-63bf2b340e89"
          x1="1218.55"
          y1="533.26"
          x2="1219.35"
          y2="634.01"
          xlinkHref="#efb1ddfb-8536-47bc-b431-af6dbf9a0bda"
        />
        <linearGradient
          id="a6dbe83d-9c0c-4ea0-aa89-193e0d18b980"
          x1="1287.79"
          y1="527.85"
          x2="1288.65"
          y2="636.03"
          xlinkHref="#efb1ddfb-8536-47bc-b431-af6dbf9a0bda"
        />
      </defs>
      <g opacity="0.47">
        <path
          d="M1335.38,89.73a5.1,5.1,0,0,0,1.58-9.59c-4.38-2.19-10.15-3.12-15.19-1,15-6.41,22.6-14.24,12.82-21.36-7.83-5.69-19.93,14.95-22.78,14.95s1.42-8.54,7.83-16.37,5.69-14.23.71-16.37-13.52,1.42-15.66,23.49c0-3.56,1.43-25.62-4.27-23.49s-10,14.24-.71,27.05c-5.69,2.13-5-3.56-5-3.56s-2.85-21.35-12.81-17.08-7.12,15.65,0,22.77,7.12,11.39-2.14,7.12-13.52-14.24-22.06-4.27,15,22.06,28.47,22.77C1296,95.35,1321.88,91.75,1335.38,89.73Z"
          fill="url(#fda8daaa-1ae8-4e76-9136-26b1ff7dd8cc)"
        />
        <path
          d="M1326.77,87.81c.5-4-7.08-8.09-13.15-3,9.1-8.09,11.12-14.67,6.57-14.67s-14.66,8.6-16.68,8.6,4.46-3.94,9-9.5,2.12-9.87-1.42-11.39c-3.32-1.42-13.38,1.78-16,15a2.29,2.29,0,0,1-1.58,1.74c-.78.26-1.67-1.8-1.67-1.8s-4.55-17.32-11.63-14.29-5,11.13,0,16.18,5.06,8.09-1.51,5.06-9.61-10.11-15.68-3,7.08,10.61,16.69,11.12S1326.77,87.81,1326.77,87.81Z"
          fill="#318099"
        />
        <path
          d="M1309.1,93.48c-1.9-.69,5.54-2.19,11.7-5.88s5.33-8.57,2.52-11.2c-2.64-2.46-13.19-2.87-20.11,8.71a2.3,2.3,0,0,1-2.07,1.11c-.83,0-1-2.27-1-2.27s1.58-17.83-6.11-17.38-8.52,8.76-5.48,15.23,2,9.32-3.14,4.24-5.61-12.77-13.72-8.16,3.07,12.38,11.93,16.11S1311,94.16,1309.1,93.48Z"
          fill="#318099"
        />
      </g>
      <g opacity="0.47">
        <path
          d="M453.05,177.1a5.1,5.1,0,0,0,1.58-9.59c-4.37-2.19-10.14-3.12-15.18-1,14.95-6.41,22.6-14.24,12.81-21.36-7.83-5.69-19.92,14.95-22.77,14.95s1.42-8.54,7.83-16.37,5.69-14.23.71-16.37-13.52,1.42-15.66,23.49c0-3.56,1.42-25.62-4.27-23.49s-10,14.24-.71,27c-5.69,2.13-5-3.56-5-3.56s-2.85-21.35-12.81-17.08-7.12,15.65,0,22.77,7.11,11.39-2.14,7.12-13.52-14.24-22.06-4.27,14.94,22.06,28.47,22.77C413.67,182.72,439.56,179.12,453.05,177.1Z"
          fill="url(#f476cdfd-d7f1-4299-87df-c32f46c039d2)"
        />
        <path
          d="M444.44,175.18c.51-4.05-7.07-8.09-13.14-3,9.1-8.08,11.12-14.66,6.57-14.66s-14.66,8.6-16.68,8.6,4.46-3.94,9-9.5,2.12-9.87-1.42-11.39c-3.32-1.42-13.39,1.78-16,15a2.29,2.29,0,0,1-1.58,1.74c-.78.26-1.67-1.8-1.67-1.8s-4.55-17.32-11.63-14.29-5.06,11.13,0,16.18,5.06,8.09-1.52,5.06-9.6-10.11-15.67-3,7.08,10.61,16.68,11.12S444.44,175.18,444.44,175.18Z"
          fill="#318099"
        />
        <path
          d="M426.78,180.85c-1.9-.69,5.53-2.19,11.7-5.88s5.33-8.57,2.52-11.2c-2.64-2.46-13.2-2.87-20.11,8.71a2.31,2.31,0,0,1-2.07,1.11c-.83,0-1-2.27-1-2.27s1.59-17.83-6.1-17.38-8.53,8.76-5.48,15.23,2,9.32-3.14,4.24-5.61-12.77-13.72-8.16,3.06,12.38,11.93,16.11S428.68,181.53,426.78,180.85Z"
          fill="#318099"
        />
      </g>
      <g id="b79246d6-777f-4dd7-b282-6a4474fc6dc0" data-name="decor">
        <path
          d="M1007.72,74.06c-1.8-4.45-5.55-13.2-4.3-20.56s2.64-16.54.83-19.31"
          fill="#3499c1"
        />
        <path
          d="M1011.75,23.07c1.39,4.59,2.22,5,0,10.42s-6.39,20.29-6.25,23.34S1009.25,72,1009.25,72"
          fill="#3499c1"
        />
        <path
          d="M1013.14,45.86c1,1.66-1,6.53-3.89,11s-3.75,17.23-3.75,17.23"
          fill="#3499c1"
        />
        <path
          d="M1003.14,16.54c-.56-2.5-2.64-1.95-2.36,0s.69,3.06,0,3.2-2.37,0-1.67,3.33l.69,3.33s-3.75-1.8.28,3.76c-.69.69-2.64,1,.56,3.47-.28.56-2.37.56-1,2.5s5.78,4.31,5.78,4.31,3.95-7.64,2.28-8.89-2.22.83-2.22.83,3.47-8.62,0-5.7c.14-1,3.33-6.25,0-4.58.42-1.53,1.39-6.53-1.39-2.64A5.29,5.29,0,0,0,1003.14,16.54Z"
          fill="#3499c1"
        />
        <path
          d="M1005.3,40.44s4-7.64,2.28-8.89-2.22.83-2.22.83,3.47-8.62,0-5.7c.14-1,3.34-6.25,0-4.58.42-1.53,1.39-6.53-1.39-2.64a5.29,5.29,0,0,0-1-2.92"
          fill="#3499c1"
        />
        <path
          d="M1005.36,40.44s1.53-7.64-.14-8.89-2.64-.56-2.64-.56,3.48-6.67.42-4.31c.14-1,2.5-5.42,0-4.58.14-.7.14-4.87-1.11-3.61a17.24,17.24,0,0,1,0-3.06"
          fill="#3499c1"
        />
        <path
          d="M1003.14,16.54c-.56-2.5-2.64-1.95-2.36,0s.69,3.06,0,3.2-2.37,0-1.67,3.33l.69,3.33s-3.75-1.8.28,3.76c-.69.69-2.64,1,.56,3.47-.28.56-2.37.56-1,2.5s5.78,4.31,5.78,4.31"
          fill="#3499c1"
        />
        <path
          d="M1010.36,1.67c-.55-2.5-2.64-1.94-2.36,0s.7,3.06,0,3.2-2.36,0-1.67,3.33l.7,3.34s-3.75-1.81.28,3.75c-.7.69-2.64,1,.55,3.47-.28.56-2.36.56-1,2.5s5.78,4.31,5.78,4.31,3.94-7.64,2.28-8.89-2.23.83-2.23.83,3.48-8.61,0-5.69c.14-1,3.34-6.26,0-4.59.42-1.53,1.39-6.53-1.39-2.64A5.24,5.24,0,0,0,1010.36,1.67Z"
          fill="#3499c1"
        />
        <path
          d="M1012.53,25.57s4-7.64,2.28-8.89-2.22.83-2.22.83,3.47-8.61,0-5.69c.13-1,3.33-6.26,0-4.59C1013,5.7,1014,.7,1011.2,4.59a5.29,5.29,0,0,0-1-2.92"
          fill="#3499c1"
        />
        <path
          d="M1012.59,25.57s1.52-7.64-.14-8.89-2.64-.56-2.64-.56,3.47-6.67.41-4.3c.14-1,2.5-5.42,0-4.59.14-.69.14-4.86-1.11-3.61a17.24,17.24,0,0,1,0-3.06"
          fill="#3499c1"
        />
        <path
          d="M1010.36,1.67c-.55-2.5-2.64-1.94-2.36,0s.7,3.06,0,3.2-2.36,0-1.67,3.33l.7,3.34s-3.75-1.81.28,3.75c-.7.69-2.64,1,.55,3.47-.28.56-2.36.56-1,2.5s5.78,4.31,5.78,4.31"
          fill="#3499c1"
        />
        <path
          d="M1019.88,23.73c.34-2.54-1.81-2.73-2.22-.81s-.4,3.11-1.1,3-2.21-.81-2.71,2.56l-.49,3.37s-2.9-3-1,3.62c-.89.41-2.81,0-.67,3.45-.45.43-2.41-.29-1.77,2s3.94,6,3.94,6,6.34-5.82,5.2-7.57-2.37,0-2.37,0,6.22-6.9,2-5.35c.47-.87,5.28-4.73,1.58-4.31.91-1.29,3.55-5.65-.4-3A5.28,5.28,0,0,0,1019.88,23.73Z"
          fill="#3499c1"
        />
        <path
          d="M1013.7,46.92s6.34-5.82,5.2-7.57-2.37,0-2.37,0,6.22-6.89,2-5.35c.47-.86,5.28-4.72,1.58-4.3.91-1.3,3.55-5.66-.4-3a5.25,5.25,0,0,0,.09-3.07"
          fill="#3499c1"
        />
        <path
          d="M1013.76,46.94s4.06-6.65,2.92-8.4-2.29-1.43-2.29-1.43,5.56-5.07,1.87-3.9c.47-.86,4.21-4.23,1.58-4.3.37-.61,1.8-4.52.2-3.78a16.68,16.68,0,0,1,1.05-2.87"
          fill="#3499c1"
        />
        <path
          d="M1019.88,23.73c.34-2.54-1.81-2.73-2.22-.81s-.4,3.11-1.1,3-2.21-.81-2.71,2.56l-.49,3.37s-2.9-3-1,3.62c-.89.41-2.81,0-.67,3.45-.45.43-2.41-.29-1.77,2s3.94,6,3.94,6"
          fill="#3499c1"
        />
      </g>
      <path
        d="M636.4,50.4c-3.12,1.59-5.53,3.6-5.72,6.79S630,63,628.31,63.36c-.47.67.07,1,.07,1s2.77-.07,3.37,1.22A6.38,6.38,0,0,0,639,68.48c-.88-.34-4.65-.44-4-3.14s2.6-2.6,2.6-2.6.4,2.46,1.18,3,3.34-.22,3.34-.22-1.95.18-2-1.08-.24-3.74-1.28-3.67.3.15,1.17-1.46-.16-3.4,1.46-4.2c-3.49.52-3.87,4.36-3.87,4.36l-1.44.09s-2-1-2.2-2.68a22.69,22.69,0,0,1,.33-4.59Z"
        fill="#314e60"
        opacity="0.33"
      />
      <path
        d="M174.66,69.83c-4.56,3.46-7.85,7.37-7.25,12.54s.59,9.43-2,10.57c-.58,1.2.38,1.55.38,1.55s4.42-.91,5.76,1A10.41,10.41,0,0,0,184,98.11c-1.53-.3-7.59.62-7.26-3.92s3.43-4.91,3.43-4.91,1.33,3.83,2.77,4.54,5.28-1.31,5.28-1.31-3.07.86-3.57-1.15-1.47-5.92-3.11-5.52.53.16,1.47-2.68-1.24-5.4,1.13-7.15c-5.45,1.83-5,8.1-5,8.1l-2.28.56s-3.55-1.06-4.3-3.68a37.57,37.57,0,0,1-.78-7.45Z"
        fill="#314e60"
        opacity="0.68"
      />
      <path
        d="M448.71,37.67c7.81,3.35,14,7.81,14.93,15.49s2.51,13.81,6.7,14.51c1.25,1.53,0,2.37,0,2.37s-6.7.28-8,3.49-7,9.91-17,8.23c2.09-1,11.16-1.81,9.07-8.23s-6.7-5.86-6.7-5.86-.56,6-2.37,7.53-8.09,0-8.09,0,4.74.14,4.74-2.93,0-9.07,2.51-9.07-.69.42-3.07-3.34-.14-8.24-4.18-9.91c8.51.7,10,9.91,10,9.91h3.49s4.75-2.8,4.89-6.84-1.54-11-1.54-11Z"
        fill="#314e60"
      />
      <path
        d="M30.68,41.05C19.87,45.68,11.38,51.85,10,62.46S6.56,81.57.77,82.53c-1.73,2.12,0,3.28,0,3.28s9.26.39,11,4.82,9.65,13.7,23.54,11.39c-2.9-1.35-15.44-2.51-12.54-11.39S32,82.53,32,82.53s.77,8.3,3.28,10.42S46.5,93,46.5,93s-6.56.19-6.56-4,0-12.54-3.47-12.54,1,.58,4.24-4.63S40.9,60.34,46.5,58c-11.77,1-13.89,13.7-13.89,13.7H27.78S21.22,67.87,21,62.27,23.15,47,23.15,47Z"
        fill="#314e60"
      />
      <g>
        <g opacity="0.32">
          <path
            d="M994.87,99s14.62-11.62,16.3-17,4-5.47,1.87-6.31c-6.3-2.51-4.7-10.23,9.44-5.48,17.64,5.94,16.13,13.17,2.9,11.16-3.23,2.19-4.33,3.67-6,4.86-1.32,1,2.07,8.25-21.49,15.82Z"
            fill="#a13172"
          />
          <ellipse
            cx="1022.84"
            cy="75.31"
            rx="2.98"
            ry="10.39"
            transform="translate(626.6 1021.28) rotate(-71.48)"
            fill="#a13172"
          />
          <path
            d="M1012.67,92.23c4.39-.56,7.55-2.14,10.52-2.78s6.21-3.28,9.36-4.41S1045.87,81.21,1042,73c-4.74-3.66.89-8,13.73-3.63s15.1,8,12.16,9.86c-1.94,1.25-2.52,6.07-15.15,7.17s-19,3.7-19.9,4.67-3.58,6.17-13.44,8-23.31,3.48-23.31,3.48Z"
            fill="#a13172"
          />
          <ellipse
            cx="1055.24"
            cy="74.19"
            rx="2.98"
            ry="10.39"
            transform="translate(649.76 1051.24) rotate(-71.48)"
            fill="#a13172"
          />
          <path
            d="M1025.89,94.7c4.45-.73,11.65.64,16.86.9,2.34.12,5.61.68,9,1,5.31.53,9.86-1.14,11-4,1.37-3.33,8.46-5.4,13.2-.42,4.45,4.68,7.36,10.42,2.87,13.4-2.38,1.58-6.55.58-9.25-1.06a15.6,15.6,0,0,0-8.42-1.93,42.82,42.82,0,0,1-12.75-1.19c-4.89-1.09-19.56-1.83-33.3,2.26-13.91,4.12-16.6,1.85-16.83,1.17a22.22,22.22,0,0,1-.43-2.72Z"
            fill="#a13172"
          />
          <ellipse
            cx="1072.81"
            cy="98.16"
            rx="4.25"
            ry="7.27"
            transform="translate(170.55 686.78) rotate(-38.35)"
            fill="#a13172"
          />
          <path
            d="M1024.12,97.79a17.47,17.47,0,0,0,8.75-6.73c.85-1,7.28-3.56,19.9-4.67,10.35-.9,12.7-4.1,13.81-6.12A27.78,27.78,0,0,1,1054,79.21c1.92,2.17,2.79,3.28-.9,4.56s-5.55-.62-15.69,4.15-9.18,8.24-15.88,9c-4.52.49-13.27,3.12-18.49,4.78,2.37-.32,5.14-.72,8-1.16Z"
            fill="#a13172"
            opacity="0.47"
          />
          <g>
            <path
              d="M1042.21,73.41c1.17,2.8.69,4.94-.56,6.58,3.33-2.19,8.47-2,8.47-2A29.48,29.48,0,0,1,1042.21,73.41Z"
              fill="#a13172"
              opacity="0.47"
            />
            <polygon
              points="1039.83 81.73 1039.83 81.73 1039.83 81.73 1039.83 81.73"
              fill="#a13172"
            />
          </g>
          <path
            d="M1015.16,103.65c13.74-4.09,28.41-3.35,33.3-2.26,7.13,2,16.92.65,20.74,2.4,0,0-4.2-3.64-4.76-6-1,2.81-2,3.79-7.85,3.83s-7.58-1.24-13.13-1.85A101.67,101.67,0,0,0,1025,100c-4,.47-17.18,4.69-20.26,4.76s-6.45.07-6.45.07l3.1,1.21C1003.85,106.2,1008,105.76,1015.16,103.65Z"
            fill="#a13172"
            opacity="0.47"
          />
          <path
            d="M1000.66,96c3.21-.85,2.79-4.47,7.2-6.83s3.69-4.7,5.68-7.46,2.94-2.27,5.32-3a16.5,16.5,0,0,1-5-2.11h0c-.18.68-1.57,1.92-2.69,5.49-1.68,5.36-16.3,17-16.3,17C996.41,98.77,997.45,96.86,1000.66,96Z"
            fill="#a13172"
            opacity="0.47"
          />
          <path
            d="M1016.09,93.42c2.9-.48,9.51-3.12,11.84-4.18s13.1-5.41,12.53-6.45a8.6,8.6,0,0,0-.68-1,21.5,21.5,0,0,1-5.38,2.63h0s-4.58,2.29-8,3.8a13.09,13.09,0,0,1-3.18,1.25l-.87.21c-2.72.72-1.18,1.09-5.15,1.6C1015.5,92.3,1013.18,93.89,1016.09,93.42Z"
            fill="#a13172"
          />
          <path
            d="M1077.32,97.35c-1.69-3.18-4.88-5.59-7.39-5.47a2.7,2.7,0,0,0-2.63,2.42C1070.59,92.35,1075.12,95.5,1077.32,97.35Z"
            fill="#a13172"
            opacity="0.47"
          />
          <path
            d="M1057.21,71.73c-5.36-2-10.58-2.48-11.67-1.12-.38.48-.17,1.14.46,1.86,1.58-3.32,16.84,2.47,17.9,2.88A21.83,21.83,0,0,0,1057.21,71.73Z"
            fill="#a13172"
            opacity="0.47"
          />
          <path
            d="M1024.05,72.84l-1-.57c-4.71-1.48-9-1.75-9.94-.54-.46.57-.08,1.39.87,2.28.29-.09,1,.3,2.43,1.71l.27.16C1013.45,70.29,1024.05,72.84,1024.05,72.84Z"
            fill="#a13172"
            opacity="0.47"
          />
        </g>
        <g>
          <path
            d="M992.37,103.58s-9-20.1-14.73-25.47-5.13-7.23-6.75-6.24c-4.86,2.95-13.34-4.16-3.47-11.44,12.33-9.08,20.27-2.42,13.86,6.24,1.56,4.16,2.94,6.13,3.81,8.32.7,1.73,10.22,4.68,11.78,28.59Z"
            fill="#64cc2b"
          />
          <ellipse
            cx="973.4"
            cy="63.99"
            rx="8.58"
            ry="4.07"
            transform="translate(127.76 550.29) rotate(-33.66)"
            fill="#170"
          />
          <path
            d="M989.94,84.69c.7-3.81-.17-7.45,0-10.22s-1.9-7.28-2.25-10.57-.35-13.17-11.09-16.46c-5.7.87-9-6.76,0-13.34s13.91-5.59,15.21-1.88c.86,2.45,6.28,6.56,3.68,17.13s-1.56,17.5-.7,18.88,6.07,7.45,5.2,16.46-3.12,20.62-3.12,20.62Z"
            fill="#64cc2b"
          />
          <ellipse
            cx="982.06"
            cy="38.17"
            rx="8.58"
            ry="4.07"
            transform="translate(143.52 550.77) rotate(-33.66)"
            fill="#170"
          />
          <path
            d="M996.87,76.37c.52-4,4.34-8.49,6.24-12.3.86-1.71,2.52-3.81,4-6.16a9.57,9.57,0,0,0-1.29-11.59c-3.45-3.59-3.68-10.62,3.57-10.49,6.81.13,14.38,2.26,16.46,8,1.1,3-1.34,5.5-4.07,6.33a7.53,7.53,0,0,0-4.83,5,20.46,20.46,0,0,1-5.31,8.92c-2.77,3-8.14,13.69-7.62,27.38.52,13.86-3,14.2-3.81,13.86s-3.3-1.73-3.3-1.73Z"
            fill="#64cc2b"
          />
          <ellipse
            cx="1015.33"
            cy="42.85"
            rx="4.07"
            ry="8.58"
            transform="translate(671.69 999.22) rotate(-72.65)"
            fill="#170"
          />
          <path
            d="M999.93,80.1c-.81-6.46-4.43-10.73-5.14-11.87-.86-1.38-1.9-8.31.7-18.88,2.13-8.67-.86-12.91-2.87-15.3a13.78,13.78,0,0,1-5.1,8.89c3.12.17,4.68.34,5,4.15s-2.42,3.82,0,15.25,6.76,13.34,5.55,19.06c-.82,3.85-.46,12.6-.13,17.88.35-2.07.74-4.51,1.1-7Z"
            fill="#11366d"
            opacity="0.47"
          />
          <g>
            <path
              d="M977.15,47.62a14.28,14.28,0,0,1,7.47,5.43,11.31,11.31,0,0,1,.3-8A19.38,19.38,0,0,1,977.15,47.62Z"
              fill="#11366d"
              opacity="0.47"
            />
            <polygon
              points="986.09 55.79 986.09 55.79 986.09 55.79 986.09 55.79"
              fill="#170"
            />
          </g>
          <path
            d="M1004,91.45c-.52-13.69,4.85-24.43,7.62-27.38,4.5-4,5.95-12.54,9.17-14.15,0,0-5.53.47-8.48-.92,3,3,3.77,4.46,2,9s-3.77,4.9-6.19,8.71-4.68,10.92-5.38,14.38.18,16.81-.69,19.23-1.9,5-1.9,5l2.35-1.48C1003.46,102.1,1004.24,98.55,1004,91.45Z"
            fill="#11366d"
            opacity="0.47"
          />
          <path
            d="M990.64,96.82c0-3.12-4.33-5.55-5.72-10.74s-4.33-6.41-6.93-10-1.73-4-1.91-6.41a9.14,9.14,0,0,1-4,2.24h0a55.32,55.32,0,0,0,5.54,6.25c5.72,5.37,14.73,25.47,14.73,25.47C992.54,102.19,990.64,99.94,990.64,96.82Z"
            fill="#11366d"
            opacity="0.47"
          />
          <path
            d="M992.37,83c.35-2.6-.69-9.7-1.21-12.3s-2.26-14.21-3.64-14.56a13.1,13.1,0,0,0-1.4-.25,22,22,0,0,1,1.4,6.14h0s1.25,5.27,2,9.08a11.66,11.66,0,0,1,.47,3.4c0,.24,0,.52,0,.83,0,2.65.91,1.74.28,5.18C990.89,82.56,992,85.56,992.37,83Z"
            fill="#86e04b"
          />
          <path
            d="M1015.78,38.76c-4.22-1.11-8-.49-8.64,1.53-.37,1.19.45,2.61,2,3.87C1007.89,40.14,1013,39.05,1015.78,38.76Z"
            fill="#11366d"
            opacity="0.47"
          />
          <path
            d="M979.8,34.78c-3.94,2.63-6.12,6.27-4.88,8.15a2.81,2.81,0,0,0,2.3,1c-3.38-3.74,8-11.1,8.85-11.6A13.76,13.76,0,0,0,979.8,34.78Z"
            fill="#11366d"
            opacity="0.47"
          />
          <path
            d="M970.9,61.18l-1,.31c-3.16,2.5-4.79,5.58-3.68,7.25a3.16,3.16,0,0,0,2.91,1.06c0-.29.65-.53,2.74-.57l.28-.09C964.68,67.41,970.9,61.18,970.9,61.18Z"
            fill="#11366d"
            opacity="0.47"
          />
        </g>
        <path
          d="M1007.61,49a6.5,6.5,0,0,1,.92,3.3,12.11,12.11,0,0,1-.39,3.45,21.82,21.82,0,0,1-2.83,6.27c-1.2,1.88-2.39,3.77-3.63,5.62s-2.5,3.71-3.83,5.53a47.26,47.26,0,0,1,2.74-6.17c1-2,2.18-3.92,3.36-5.83a30.49,30.49,0,0,0,3-5.78,14.59,14.59,0,0,0,.8-3.12A7.87,7.87,0,0,0,1007.61,49Z"
          fill="#86e04b"
        />
        <path
          d="M1010.31,36.24c-.91.52-1.78,1-2.57,1.48a5.3,5.3,0,0,0-1.82,1.71,2.66,2.66,0,0,0-.06,2.21,23.46,23.46,0,0,0,1.23,2.65,5.89,5.89,0,0,1-2.36-2.11,3.72,3.72,0,0,1-.6-1.65,3.21,3.21,0,0,1,.38-1.87,4.73,4.73,0,0,1,2.69-2.07A6.74,6.74,0,0,1,1010.31,36.24Z"
          fill="#86e04b"
        />
        <path
          d="M975.94,37.05c-.56.88-1.12,1.69-1.58,2.5a5.36,5.36,0,0,0-.81,2.37,2.65,2.65,0,0,0,1,2,21.93,21.93,0,0,0,2.32,1.76,5.87,5.87,0,0,1-3.07-.75,3.67,3.67,0,0,1-1.3-1.19,3.18,3.18,0,0,1-.54-1.82,4.73,4.73,0,0,1,1.41-3.09A6.9,6.9,0,0,1,975.94,37.05Z"
          fill="#86e04b"
        />
        <path
          d="M966.87,62c-.47,1-.91,1.9-1.24,2.81a5.77,5.77,0,0,0-.41,2.61,3.55,3.55,0,0,0,1.18,2.16,2.68,2.68,0,0,0,.54.46l.58.48a12.26,12.26,0,0,1,1.29.91,12.8,12.8,0,0,1-1.62-.2,7.19,7.19,0,0,1-1.55-.65,4,4,0,0,1-2-3,5.11,5.11,0,0,1,.89-3.38A6.74,6.74,0,0,1,966.87,62Z"
          fill="#86e04b"
        />
      </g>
      <g>
        <g>
          <path
            d="M1064.68,205.73s-2.78-6.18-4.54-7.84-1.57-2.22-2.07-1.92c-1.5.91-4.11-1.28-1.07-3.52,3.79-2.79,6.24-.74,4.26,1.92.48,1.28.91,1.89,1.18,2.56s3.14,1.44,3.62,8.8Z"
            fill="#318099"
          />
          <ellipse
            cx="1058.84"
            cy="193.55"
            rx="2.64"
            ry="1.25"
            transform="translate(70.27 619.38) rotate(-33.66)"
            fill="#318099"
          />
          <path
            d="M1063.93,199.92a20.59,20.59,0,0,0,0-3.15c0-.85-.59-2.24-.69-3.25s-.11-4.05-3.41-5.06c-1.76.26-2.78-2.08,0-4.11s4.27-1.72,4.67-.58c.27.76,1.94,2,1.14,5.27s-.48,5.39-.22,5.81a7.34,7.34,0,0,1,1.6,5.07c-.26,2.77-1,6.34-1,6.34Z"
            fill="#318099"
          />
          <ellipse
            cx="1061.5"
            cy="185.6"
            rx="2.64"
            ry="1.25"
            transform="translate(75.12 619.52) rotate(-33.66)"
            fill="#318099"
          />
          <path
            d="M1066.06,197.36c.16-1.23,1.34-2.61,1.92-3.79.27-.52.78-1.17,1.22-1.89a2.94,2.94,0,0,0-.4-3.57c-1.06-1.1-1.13-3.27,1.1-3.23s4.43.7,5.07,2.46a1.56,1.56,0,0,1-1.25,1.94,2.31,2.31,0,0,0-1.49,1.55,6.24,6.24,0,0,1-1.63,2.74c-.86.91-2.51,4.22-2.35,8.43s-.91,4.37-1.17,4.26-1-.53-1-.53Z"
            fill="#318099"
          />
          <ellipse
            cx="1071.74"
            cy="187.04"
            rx="1.25"
            ry="2.64"
            transform="translate(573.65 1154.27) rotate(-72.65)"
            fill="#318099"
          />
          <path
            d="M1067,198.51a8,8,0,0,0-1.58-3.66c-.26-.42-.58-2.56.22-5.81.65-2.66-.27-4-.89-4.71a4.2,4.2,0,0,1-1.57,2.74c1,.05,1.44.11,1.55,1.28s-.75,1.17,0,4.69,2.08,4.11,1.71,5.87a28.51,28.51,0,0,0,0,5.5c.11-.64.23-1.39.34-2.17Z"
            fill="#318099"
            opacity="0.47"
          />
          <g>
            <path
              d="M1060,188.51a4.39,4.39,0,0,1,2.3,1.67,3.54,3.54,0,0,1,.09-2.47A5.79,5.79,0,0,1,1060,188.51Z"
              fill="#318099"
              opacity="0.47"
            />
            <polygon
              points="1062.75 191.02 1062.75 191.02 1062.75 191.02 1062.75 191.02"
              fill="#318099"
            />
          </g>
          <path
            d="M1068.25,202c-.16-4.21,1.49-7.52,2.35-8.43,1.38-1.22,1.83-3.86,2.82-4.35a6.71,6.71,0,0,1-2.61-.28,2,2,0,0,1,.63,2.75c-.54,1.39-1.16,1.51-1.91,2.68a16,16,0,0,0-1.65,4.43c-.22,1.07,0,5.17-.22,5.92s-.58,1.54-.58,1.54l.72-.45A8,8,0,0,0,1068.25,202Z"
            fill="#318099"
            opacity="0.47"
          />
          <path
            d="M1064.14,203.65c0-1-1.33-1.7-1.76-3.3s-1.33-2-2.13-3.1a2.31,2.31,0,0,1-.58-2,2.89,2.89,0,0,1-1.23.69h0a16.37,16.37,0,0,0,1.7,1.92c1.76,1.66,4.54,7.84,4.54,7.84C1064.73,205.31,1064.14,204.61,1064.14,203.65Z"
            fill="#318099"
            opacity="0.47"
          />
          <path
            d="M1064.68,199.39a18.74,18.74,0,0,0-.38-3.79c-.16-.8-.69-4.37-1.12-4.48a4,4,0,0,0-.43-.08,6.7,6.7,0,0,1,.43,1.89h0s.39,1.63.61,2.8a3.83,3.83,0,0,1,.14,1,2.44,2.44,0,0,1,0,.26c0,.81.28.54.09,1.6C1064.22,199.26,1064.57,200.19,1064.68,199.39Z"
            fill="#318099"
          />
          <path
            d="M1071.88,185.79c-1.3-.35-2.46-.16-2.66.47-.11.36.14.8.62,1.19C1069.46,186.21,1071,185.87,1071.88,185.79Z"
            fill="#318099"
            opacity="0.47"
          />
          <path
            d="M1060.81,184.56c-1.21.81-1.89,1.93-1.5,2.51a.87.87,0,0,0,.71.32c-1-1.15,2.47-3.41,2.72-3.57A4.22,4.22,0,0,0,1060.81,184.56Z"
            fill="#318099"
            opacity="0.47"
          />
          <path
            d="M1058.07,192.68l-.3.1c-1,.77-1.47,1.72-1.13,2.23a1,1,0,0,0,.9.33c0-.09.2-.17.84-.18l.09,0C1056.16,194.6,1058.07,192.68,1058.07,192.68Z"
            fill="#318099"
            opacity="0.47"
          />
        </g>
        <path
          d="M1069.37,189s.72,1.26-.83,3.73-2.18,3.7-2.18,3.7"
          fill="#318099"
        />
        <path d="M1070.2,185s-3,.49-1,2.47" fill="#318099" />
        <path d="M1059.62,185.26s-2.39,1.82.28,2.65" fill="#318099" />
        <path d="M1056.83,192.93s-2.08,2.07.6,2.9" fill="#318099" />
      </g>
      <g>
        <g>
          <path
            d="M1224.09,186.54s-3.55-7.91-5.8-10-2-2.85-2.67-2.46c-1.91,1.16-5.25-1.64-1.36-4.5,4.86-3.58,8-1,5.46,2.45.61,1.64,1.16,2.42,1.5,3.28.27.68,4,1.84,4.64,11.26Z"
            fill="#318099"
          />
          <ellipse
            cx="1216.61"
            cy="170.95"
            rx="3.38"
            ry="1.6"
            transform="translate(109.26 703.04) rotate(-33.66)"
            fill="#318099"
          />
          <path
            d="M1223.13,179.1a25.54,25.54,0,0,0,0-4c.07-1.1-.75-2.87-.89-4.17s-.13-5.19-4.36-6.48c-2.25.34-3.55-2.67,0-5.26s5.47-2.2,6-.74c.34,1,2.47,2.58,1.45,6.75s-.62,6.89-.28,7.44a9.33,9.33,0,0,1,2,6.48c-.34,3.55-1.23,8.13-1.23,8.13Z"
            fill="#318099"
          />
          <ellipse
            cx="1220.03"
            cy="160.77"
            rx="3.38"
            ry="1.6"
            transform="translate(115.47 703.23) rotate(-33.66)"
            fill="#318099"
          />
          <path
            d="M1225.86,175.83c.21-1.57,1.71-3.35,2.46-4.85.34-.68,1-1.5,1.56-2.43a3.78,3.78,0,0,0-.51-4.57c-1.36-1.41-1.45-4.18,1.41-4.13,2.68.05,5.66.89,6.48,3.14a2,2,0,0,1-1.6,2.5,2.93,2.93,0,0,0-1.9,2,8.23,8.23,0,0,1-2.09,3.52c-1.1,1.16-3.21,5.39-3,10.79s-1.16,5.59-1.5,5.46-1.3-.69-1.3-.69Z"
            fill="#318099"
          />
          <ellipse
            cx="1233.13"
            cy="162.62"
            rx="1.6"
            ry="3.38"
            transform="translate(710.24 1291.17) rotate(-72.65)"
            fill="#318099"
          />
          <path
            d="M1227.07,177.29a10.09,10.09,0,0,0-2-4.67c-.34-.55-.75-3.28.28-7.44.84-3.42-.34-5.09-1.13-6a5.5,5.5,0,0,1-2,3.5c1.23.07,1.84.14,2,1.64s-1,1.5,0,6,2.66,5.25,2.18,7.51a36.35,36.35,0,0,0,0,7c.14-.82.29-1.78.44-2.77Z"
            fill="#318099"
            opacity="0.47"
          />
          <g>
            <path
              d="M1218.09,164.5a5.54,5.54,0,0,1,2.94,2.14,4.52,4.52,0,0,1,.12-3.17A7.55,7.55,0,0,1,1218.09,164.5Z"
              fill="#318099"
              opacity="0.47"
            />
            <polygon
              points="1221.62 167.71 1221.62 167.71 1221.62 167.71 1221.62 167.71"
              fill="#318099"
            />
          </g>
          <path
            d="M1228.66,181.77c-.2-5.4,1.91-9.63,3-10.79,1.77-1.57,2.34-4.94,3.61-5.58a8.34,8.34,0,0,1-3.34-.36c1.16,1.16,1.48,1.76.8,3.53s-1.48,1.93-2.44,3.43a20.84,20.84,0,0,0-2.12,5.67c-.27,1.36.07,6.62-.27,7.58s-.75,2-.75,2l.93-.58C1228.46,186,1228.77,184.56,1228.66,181.77Z"
            fill="#318099"
            opacity="0.47"
          />
          <path
            d="M1223.41,183.88c0-1.23-1.71-2.18-2.26-4.23s-1.7-2.53-2.73-4a3,3,0,0,1-.75-2.53,3.55,3.55,0,0,1-1.57.89h0a22.3,22.3,0,0,0,2.19,2.46c2.25,2.12,5.8,10,5.8,10C1224.16,186,1223.41,185.11,1223.41,183.88Z"
            fill="#318099"
            opacity="0.47"
          />
          <path
            d="M1224.09,178.42a23.53,23.53,0,0,0-.48-4.85c-.2-1-.89-5.59-1.43-5.73a4.44,4.44,0,0,0-.56-.1,8.73,8.73,0,0,1,.56,2.42h0s.49,2.08.77,3.58a4.55,4.55,0,0,1,.18,1.34c0,.09,0,.2,0,.32,0,1,.36.69.11,2C1223.51,178.26,1224,179.44,1224.09,178.42Z"
            fill="#318099"
          />
          <path
            d="M1233.31,161c-1.66-.44-3.15-.2-3.4.6-.15.47.18,1,.79,1.52C1230.21,161.55,1232.2,161.12,1233.31,161Z"
            fill="#318099"
            opacity="0.47"
          />
          <path
            d="M1219.14,159.44c-1.56,1-2.42,2.47-1.93,3.21a1.11,1.11,0,0,0,.91.41c-1.33-1.47,3.17-4.37,3.49-4.57A5.33,5.33,0,0,0,1219.14,159.44Z"
            fill="#318099"
            opacity="0.47"
          />
          <path
            d="M1215.63,169.84l-.38.12c-1.25,1-1.89,2.2-1.45,2.86a1.23,1.23,0,0,0,1.15.41c0-.11.25-.2,1.08-.22l.11,0C1213.18,172.3,1215.63,169.84,1215.63,169.84Z"
            fill="#318099"
            opacity="0.47"
          />
        </g>
        <path
          d="M1230.09,165.05s.93,1.62-1.06,4.79-2.78,4.74-2.78,4.74"
          fill="#318099"
        />
        <path d="M1231.16,160s-3.81.64-1.27,3.17" fill="#318099" />
        <path d="M1217.62,160.33s-3.07,2.34.35,3.4" fill="#318099" />
        <path d="M1214,170.16s-2.66,2.65.77,3.71" fill="#318099" />
      </g>
      <g>
        <g>
          <path
            d="M1223.22,75.86s-3-6.7-4.91-8.5-1.71-2.41-2.26-2.08c-1.61,1-4.44-1.38-1.15-3.81,4.11-3,6.76-.81,4.62,2.08.52,1.39,1,2,1.27,2.77s3.41,1.56,3.93,9.54Z"
            fill="#318099"
          />
          <ellipse
            cx="1216.89"
            cy="62.66"
            rx="2.86"
            ry="1.36"
            transform="translate(169.33 685.04) rotate(-33.66)"
            fill="#318099"
          />
          <path
            d="M1222.41,69.56a22.7,22.7,0,0,0,0-3.41c.06-.92-.64-2.43-.75-3.52s-.12-4.39-3.7-5.49c-1.9.29-3-2.25,0-4.45s4.64-1.86,5.07-.63c.29.82,2.09,2.19,1.23,5.71s-.52,5.84-.23,6.3a8,8,0,0,1,1.73,5.49c-.29,3-1,6.87-1,6.87Z"
            fill="#318099"
          />
          <ellipse
            cx="1219.78"
            cy="54.05"
            rx="2.86"
            ry="1.36"
            transform="translate(174.58 685.2) rotate(-33.66)"
            fill="#318099"
          />
          <path
            d="M1224.72,66.79c.17-1.33,1.44-2.83,2.08-4.11.29-.57.84-1.27,1.32-2a3.2,3.2,0,0,0-.43-3.87c-1.15-1.19-1.23-3.54,1.19-3.49,2.27,0,4.8.75,5.49,2.65A1.69,1.69,0,0,1,1233,58a2.53,2.53,0,0,0-1.61,1.68,6.75,6.75,0,0,1-1.77,3c-.92,1-2.71,4.57-2.54,9.13s-1,4.74-1.27,4.62-1.1-.57-1.1-.57Z"
            fill="#318099"
          />
          <ellipse
            cx="1230.87"
            cy="55.61"
            rx="1.36"
            ry="2.86"
            transform="translate(810.79 1213.91) rotate(-72.65)"
            fill="#318099"
          />
          <path
            d="M1225.74,68a8.66,8.66,0,0,0-1.71-4c-.29-.46-.64-2.77.23-6.3.71-2.89-.29-4.3-1-5.1a4.62,4.62,0,0,1-1.7,3c1,0,1.56.11,1.68,1.38s-.81,1.27,0,5.09,2.25,4.45,1.84,6.35a30.87,30.87,0,0,0,0,6c.12-.69.25-1.5.37-2.34Z"
            fill="#318099"
            opacity="0.47"
          />
          <g>
            <path
              d="M1218.14,57.2a4.71,4.71,0,0,1,2.49,1.81,3.82,3.82,0,0,1,.1-2.68A6.43,6.43,0,0,1,1218.14,57.2Z"
              fill="#318099"
              opacity="0.47"
            />
            <polygon
              points="1221.13 59.92 1221.13 59.92 1221.13 59.92 1221.13 59.92"
              fill="#318099"
            />
          </g>
          <path
            d="M1227.09,71.81c-.17-4.56,1.62-8.14,2.54-9.13,1.5-1.32,2-4.18,3.06-4.72a7.15,7.15,0,0,1-2.83-.3c1,1,1.26,1.48.68,3s-1.26,1.63-2.06,2.9a17.75,17.75,0,0,0-1.8,4.8c-.23,1.15.06,5.6-.23,6.41s-.63,1.67-.63,1.67l.78-.49C1226.92,75.37,1227.18,74.18,1227.09,71.81Z"
            fill="#318099"
            opacity="0.47"
          />
          <path
            d="M1222.64,73.6c0-1-1.44-1.84-1.91-3.58s-1.44-2.14-2.31-3.35a2.53,2.53,0,0,1-.63-2.14,3.05,3.05,0,0,1-1.33.75h0a17.72,17.72,0,0,0,1.85,2.08c1.9,1.8,4.91,8.5,4.91,8.5C1223.28,75.39,1222.64,74.64,1222.64,73.6Z"
            fill="#318099"
            opacity="0.47"
          />
          <path
            d="M1223.22,69a19.73,19.73,0,0,0-.41-4.1c-.17-.87-.75-4.74-1.21-4.85a3.2,3.2,0,0,0-.47-.09,7.24,7.24,0,0,1,.47,2.05h0s.42,1.76.65,3a3.78,3.78,0,0,1,.16,1.13c0,.08,0,.17,0,.28,0,.88.3.58.09,1.73C1222.73,68.85,1223.1,69.85,1223.22,69Z"
            fill="#318099"
          />
          <path
            d="M1231,54.24c-1.4-.37-2.67-.16-2.88.51-.12.4.15.87.67,1.3C1228.4,54.7,1230.08,54.34,1231,54.24Z"
            fill="#318099"
            opacity="0.47"
          />
          <path
            d="M1219,52.92c-1.32.87-2,2.09-1.63,2.71a1,1,0,0,0,.77.36c-1.13-1.25,2.68-3.71,2.95-3.87A4.5,4.5,0,0,0,1219,52.92Z"
            fill="#318099"
            opacity="0.47"
          />
          <path
            d="M1216.06,61.72l-.32.1c-1.06.84-1.6,1.86-1.23,2.42a1.06,1.06,0,0,0,1,.35c0-.09.22-.17.92-.18l.09,0C1214,63.8,1216.06,61.72,1216.06,61.72Z"
            fill="#318099"
            opacity="0.47"
          />
        </g>
        <path d="M1228.3,57.67s.78,1.37-.9,4-2.35,4-2.35,4" fill="#318099" />
        <path d="M1229.2,53.4s-3.22.54-1.07,2.69" fill="#318099" />
        <path d="M1217.74,53.67s-2.6,2,.3,2.88" fill="#318099" />
        <path d="M1214.72,62s-2.26,2.24.64,3.14" fill="#318099" />
      </g>
      <g>
        <g>
          <path
            d="M1074.61,71.72s-4.15-9.25-6.78-11.72-2.36-3.32-3.11-2.87c-2.23,1.36-6.13-1.91-1.59-5.26,5.67-4.18,9.32-1.11,6.38,2.87.71,1.91,1.35,2.82,1.75,3.83.32.79,4.7,2.15,5.42,13.15Z"
            fill="#318099"
          />
          <ellipse
            cx="1065.88"
            cy="53.51"
            rx="3.94"
            ry="1.87"
            transform="translate(149.08 599.8) rotate(-33.66)"
            fill="#318099"
          />
          <path
            d="M1073.49,63c.32-1.75-.08-3.43,0-4.7s-.88-3.35-1-4.86-.15-6.06-5.1-7.57c-2.62.4-4.14-3.11,0-6.14s6.4-2.57,7-.86c.39,1.12,2.89,3,1.69,7.87s-.72,8-.32,8.69a11,11,0,0,1,2.39,7.57c-.4,4.14-1.43,9.48-1.43,9.48Z"
            fill="#318099"
          />
          <ellipse
            cx="1069.86"
            cy="41.63"
            rx="3.94"
            ry="1.87"
            transform="translate(156.33 600.02) rotate(-33.66)"
            fill="#318099"
          />
          <path
            d="M1076.68,59.2c.24-1.83,2-3.9,2.87-5.65.39-.79,1.15-1.76,1.82-2.84a4.41,4.41,0,0,0-.6-5.33c-1.58-1.65-1.69-4.88,1.65-4.82,3.13.06,6.61,1,7.57,3.66.5,1.4-.62,2.53-1.88,2.91a3.47,3.47,0,0,0-2.22,2.31,9.36,9.36,0,0,1-2.44,4.11c-1.27,1.35-3.74,6.29-3.5,12.59s-1.36,6.53-1.76,6.37-1.51-.79-1.51-.79Z"
            fill="#318099"
          />
          <ellipse
            cx="1085.16"
            cy="43.78"
            rx="1.87"
            ry="3.94"
            transform="translate(719.82 1066.54) rotate(-72.65)"
            fill="#318099"
          />
          <path
            d="M1078.08,60.92a11.79,11.79,0,0,0-2.36-5.46c-.4-.64-.87-3.83.32-8.69,1-4-.4-5.93-1.32-7a6.27,6.27,0,0,1-2.35,4.08c1.44.08,2.16.16,2.32,1.92s-1.12,1.75,0,7,3.1,6.14,2.55,8.77a42.07,42.07,0,0,0-.06,8.22c.16-.95.34-2.08.51-3.24Z"
            fill="#318099"
            opacity="0.47"
          />
          <g>
            <path
              d="M1067.61,46a6.53,6.53,0,0,1,3.43,2.5,5.21,5.21,0,0,1,.14-3.7A8.71,8.71,0,0,1,1067.61,46Z"
              fill="#318099"
              opacity="0.47"
            />
            <polygon
              points="1071.72 49.73 1071.72 49.73 1071.72 49.73 1071.72 49.73"
              fill="#318099"
            />
          </g>
          <path
            d="M1080,66.14c-.24-6.3,2.23-11.24,3.5-12.59,2.07-1.84,2.74-5.77,4.22-6.51a9.86,9.86,0,0,1-3.9-.43c1.36,1.36,1.73,2,.94,4.13s-1.74,2.25-2.85,4a24,24,0,0,0-2.47,6.62c-.32,1.59.08,7.73-.32,8.84s-.88,2.31-.88,2.31l1.09-.68C1079.71,71,1080.07,69.4,1080,66.14Z"
            fill="#318099"
            opacity="0.47"
          />
          <path
            d="M1073.81,68.61c0-1.44-2-2.55-2.63-4.94s-2-3-3.19-4.63-.79-1.83-.87-2.94a4.3,4.3,0,0,1-1.84,1h0a25.7,25.7,0,0,0,2.55,2.87c2.63,2.47,6.78,11.72,6.78,11.72C1074.69,71.08,1073.81,70,1073.81,68.61Z"
            fill="#318099"
            opacity="0.47"
          />
          <path
            d="M1074.61,62.23a27.23,27.23,0,0,0-.56-5.66c-.24-1.19-1-6.53-1.68-6.69a6.38,6.38,0,0,0-.64-.12,9.79,9.79,0,0,1,.64,2.83h0s.58,2.42.9,4.17a5.23,5.23,0,0,1,.22,1.57c0,.11,0,.24,0,.38,0,1.22.42.8.13,2.38C1073.93,62.05,1074.45,63.43,1074.61,62.23Z"
            fill="#318099"
          />
          <path
            d="M1085.37,41.91c-1.94-.52-3.68-.23-4,.7-.17.55.21,1.2.92,1.78C1081.75,42.54,1084.07,42,1085.37,41.91Z"
            fill="#318099"
            opacity="0.47"
          />
          <path
            d="M1068.83,40.07c-1.82,1.21-2.82,2.89-2.25,3.75a1.31,1.31,0,0,0,1.06.49c-1.55-1.73,3.7-5.11,4.07-5.34A6.31,6.31,0,0,0,1068.83,40.07Z"
            fill="#318099"
            opacity="0.47"
          />
          <path
            d="M1064.73,52.22l-.44.14c-1.46,1.15-2.2,2.57-1.69,3.33a1.48,1.48,0,0,0,1.34.49c0-.13.3-.24,1.26-.26l.12,0C1061.87,55.08,1064.73,52.22,1064.73,52.22Z"
            fill="#318099"
            opacity="0.47"
          />
        </g>
        <path
          d="M1081.61,46.63s1.09,1.89-1.24,5.59-3.24,5.53-3.24,5.53"
          fill="#318099"
        />
        <path d="M1082.86,40.75s-4.44.74-1.48,3.7" fill="#318099" />
        <path d="M1067.05,41.12s-3.58,2.72.42,4" fill="#318099" />
        <path d="M1062.88,52.59s-3.11,3.09.89,4.33" fill="#318099" />
      </g>
      <g>
        <path
          d="M354.9,200.39s10,20.21,53.64,17,20.93-13.76,12.45-17.09S354.9,200.39,354.9,200.39Z"
          fill="#0e3b68"
          opacity="0.32"
        />
        <g>
          <path
            d="M438.2,202.84a6,6,0,0,0,1.86-11.33c-5.17-2.58-12-3.68-17.92-1.13,17.65-7.57,26.68-16.81,15.13-25.22-9.25-6.72-23.54,17.65-26.9,17.65s1.68-10.08,9.25-19.33,6.72-16.81.84-19.33-16,1.68-18.49,27.74c0-4.21,1.68-30.26-5.05-27.74s-11.76,16.81-.84,31.94c-6.72,2.52-5.88-4.2-5.88-4.2s-3.36-25.22-15.13-20.17-8.4,18.49,0,26.89,8.41,13.45-2.52,8.41-16-16.81-26.05-5.05,17.65,26.06,33.62,26.9C391.69,209.48,422.26,205.23,438.2,202.84Z"
            fill="url(#efb1ddfb-8536-47bc-b431-af6dbf9a0bda)"
          />
          <path
            d="M428,200.57c.6-4.78-8.36-9.55-15.52-3.58,10.75-9.55,13.13-17.32,7.76-17.32s-17.31,10.15-19.7,10.15,5.27-4.64,10.64-11.21,2.5-11.66-1.68-13.45c-3.92-1.68-15.8,2.1-18.85,17.72a2.74,2.74,0,0,1-1.87,2.06c-.92.3-2-2.13-2-2.13s-5.38-20.45-13.73-16.87-6,13.14,0,19.11,6,9.55-1.8,6-11.34-11.94-18.5-3.58,8.36,12.53,19.7,13.13S428,200.57,428,200.57Z"
            fill="url(#b5e67398-3e86-4ff0-b343-db421b98d40e)"
          />
          <path
            d="M407.18,207.27c-2.25-.81,6.53-2.59,13.81-7s6.3-10.12,3-13.22c-3.12-2.91-15.58-3.39-23.74,10.28a2.72,2.72,0,0,1-2.45,1.31c-1,0-1.14-2.67-1.14-2.67s1.87-21.06-7.21-20.52-10.06,10.33-6.47,18,2.39,11-3.7,5-6.63-15.08-16.2-9.64,3.61,14.63,14.08,19S409.42,208.08,407.18,207.27Z"
            fill="url(#adda5497-7d3e-47bf-a92a-dcdc99530f70)"
          />
        </g>
      </g>
      <g>
        <path
          d="M1271.44,452.91c6.6-1,8.09-9.92,2.13-12.9s-13.64-4.2-20.41-1.29c20.09-8.62,30.38-19.14,17.22-28.71-10.53-7.66-26.79,20.09-30.62,20.09s1.91-11.48,10.52-22,7.66-19.14,1-22-18.18,1.92-21,31.58c0-4.78,1.91-34.45-5.74-31.58s-13.4,19.14-1,36.37c-7.66,2.87-6.7-4.79-6.7-4.79s-3.83-28.71-17.22-23-9.57,21.05,0,30.62,9.56,15.31-2.88,9.57-18.18-19.14-29.66-5.74,20.09,29.66,38.28,30.62C1218.49,460.46,1253.29,455.62,1271.44,452.91Z"
          fill="url(#bdc2ae7d-1f23-4c56-913b-09e026725ab7)"
        />
        <path
          d="M1259.87,450.32c.68-5.44-9.52-10.87-17.68-4.08,12.24-10.87,15-19.71,8.84-19.71s-19.71,11.56-22.43,11.56,6-5.29,12.11-12.77,2.85-13.27-1.91-15.31c-4.46-1.92-18,2.38-21.47,20.17a3.11,3.11,0,0,1-2.12,2.35c-1,.34-2.25-2.43-2.25-2.43s-6.12-23.28-15.63-19.21-6.8,15,0,21.76,6.79,10.87-2,6.8-12.92-13.6-21.08-4.08,9.52,14.27,22.44,14.95S1259.87,450.32,1259.87,450.32Z"
          fill="url(#f150496c-66cd-49a5-8ef2-235d713cec7b)"
        />
        <path
          d="M1236.12,458c-2.56-.92,7.44-2.95,15.73-7.91s7.17-11.53,3.38-15.06c-3.55-3.31-17.74-3.85-27,11.71a3.09,3.09,0,0,1-2.79,1.49c-1.11,0-1.3-3-1.3-3s2.13-24-8.2-23.37-11.47,11.77-7.37,20.47,2.71,12.53-4.22,5.7-7.55-17.16-18.45-11,4.12,16.65,16,21.67S1238.68,458.87,1236.12,458Z"
          fill="url(#fcf0278e-8c2d-46c1-9032-184b21fefdad)"
        />
      </g>
      <g>
        <path
          d="M1402.57,505.21a5.11,5.11,0,0,0,1.58-9.6c-4.38-2.18-10.14-3.12-15.18-1,15-6.4,22.6-14.23,12.81-21.35-7.83-5.69-19.93,14.95-22.77,14.95s1.42-8.54,7.83-16.37,5.69-14.24.71-16.37S1374,456.93,1371.89,479c0-3.55,1.42-25.62-4.27-23.48s-10,14.23-.71,27c-5.7,2.14-5-3.56-5-3.56s-2.85-21.35-12.81-17.08-7.12,15.66,0,22.78,7.11,11.39-2.14,7.12-13.52-14.24-22.06-4.28,14.94,22.07,28.47,22.78C1363.19,510.83,1389.07,507.23,1402.57,505.21Z"
          fill="url(#a718b927-7c43-49a9-9d91-c7844ec97086)"
        />
        <path
          d="M1394,503.28c.51-4-7.07-8.08-13.14-3,9.1-8.09,11.12-14.66,6.57-14.66s-14.66,8.59-16.68,8.59,4.46-3.93,9-9.49,2.12-9.87-1.42-11.39c-3.32-1.42-13.39,1.77-16,15a2.29,2.29,0,0,1-1.58,1.75c-.78.25-1.67-1.8-1.67-1.8s-4.55-17.32-11.63-14.29-5.06,11.12,0,16.18,5.06,8.09-1.52,5.06-9.6-10.12-15.67-3,7.08,10.62,16.68,11.12S1394,503.28,1394,503.28Z"
          fill="url(#f94341ce-bd70-4379-882a-9ca9d3495050)"
        />
        <path
          d="M1376.3,509c-1.9-.69,5.53-2.2,11.7-5.89s5.33-8.57,2.52-11.19c-2.64-2.47-13.2-2.87-20.11,8.7a2.29,2.29,0,0,1-2.07,1.11c-.83,0-1-2.26-1-2.26s1.59-17.84-6.1-17.38-8.53,8.75-5.48,15.22,2,9.33-3.14,4.25-5.61-12.77-13.72-8.17,3.06,12.39,11.93,16.12S1378.2,509.64,1376.3,509Z"
          fill="url(#a61eef57-9e30-4c59-867e-3b48aacb4f8b)"
        />
      </g>
      <g>
        <path
          d="M1130.19,551.28a5.11,5.11,0,0,0,1.57-9.6c-4.37-2.18-10.14-3.12-15.18-1,15-6.4,22.6-14.23,12.81-21.35-7.82-5.69-19.92,15-22.77,15s1.42-8.54,7.83-16.37,5.69-14.24.71-16.37-13.52,1.42-15.66,23.48c0-3.55,1.43-25.62-4.27-23.48s-10,14.23-.71,27c-5.69,2.14-5-3.56-5-3.56s-2.85-21.35-12.81-17.08-7.12,15.66,0,22.78,7.11,11.39-2.14,7.11-13.52-14.23-22.06-4.27,14.94,22.07,28.47,22.78C1090.8,556.9,1116.69,553.3,1130.19,551.28Z"
          fill="url(#b464a571-a0ce-4c66-b825-a421411fdd99)"
        />
        <path
          d="M1121.58,549.35c.5-4-7.08-8.09-13.15-3,9.1-8.09,11.12-14.66,6.57-14.66s-14.66,8.59-16.68,8.59,4.46-3.93,9-9.49,2.12-9.87-1.42-11.39c-3.32-1.42-13.39,1.77-16,15a2.29,2.29,0,0,1-1.58,1.75c-.78.25-1.67-1.8-1.67-1.8S1082.14,517,1075.06,520s-5.06,11.12,0,16.18,5.06,8.09-1.52,5-9.6-10.11-15.67-3,7.08,10.62,16.69,11.12S1121.58,549.35,1121.58,549.35Z"
          fill="url(#ada7f351-f536-44cd-917d-eb4166ca78cd)"
        />
        <path
          d="M1103.91,555c-1.9-.68,5.53-2.19,11.7-5.88s5.33-8.57,2.52-11.19c-2.64-2.47-13.2-2.87-20.11,8.7a2.28,2.28,0,0,1-2.07,1.11c-.83,0-1-2.26-1-2.26s1.59-17.84-6.1-17.38-8.52,8.75-5.48,15.22,2,9.33-3.14,4.25-5.61-12.77-13.72-8.17,3.06,12.39,11.93,16.12S1105.82,555.71,1103.91,555Z"
          fill="url(#ed242f3d-b227-4fb1-b306-869862a98d52)"
        />
      </g>
      <g>
        <path
          d="M965.07,267.3s14.87,20.49,49.65,14.41,42.57,4.59,46.47-2-13.71-21.81-31.45-23.9-64.67,11.53-64.67,11.53"
          fill="#0e3b68"
          opacity="0.32"
        />
        <g>
          <path
            d="M1053.49,268c6.39-1,7.83-9.61,2-12.49s-13.2-4.07-19.76-1.26c19.46-8.34,29.42-18.53,16.68-27.8-10.2-7.41-26,19.46-29.65,19.46s1.85-11.12,10.19-21.31,7.41-18.53.92-21.31-17.6,1.85-20.38,30.58c0-4.64,1.85-33.36-5.56-30.58s-13,18.53-.93,35.21c-7.41,2.78-6.48-4.63-6.48-4.63s-3.71-27.8-16.68-22.24-9.27,20.38,0,29.65,9.26,14.83-2.78,9.27S963.5,232,952.38,245s19.46,28.72,37.07,29.65C1002.21,275.34,1035.91,270.66,1053.49,268Z"
            fill="url(#bd3b1006-c459-4b06-a44a-430815498c36)"
          />
          <path
            d="M1042.28,265.52c.66-5.26-9.22-10.53-17.12-3.95,11.85-10.53,14.48-19.09,8.56-19.09s-19.09,11.19-21.72,11.19,5.81-5.12,11.73-12.36,2.76-12.85-1.85-14.83c-4.32-1.85-17.43,2.31-20.79,19.54a3,3,0,0,1-2.05,2.27c-1,.33-2.18-2.35-2.18-2.35s-5.93-22.55-15.14-18.6-6.59,14.49,0,21.07,6.58,10.53-2,6.58-12.5-13.16-20.4-4,9.21,13.82,21.72,14.48S1042.28,265.52,1042.28,265.52Z"
            fill="url(#f4ae110b-58a0-42a5-879d-a99d42ff9314)"
          />
          <path
            d="M1019.28,272.91c-2.48-.9,7.2-2.86,15.23-7.66s6.94-11.16,3.28-14.58c-3.44-3.21-17.18-3.73-26.18,11.34a3,3,0,0,1-2.7,1.44c-1.07,0-1.25-2.94-1.25-2.94s2.06-23.23-7.95-22.63-11.1,11.39-7.13,19.82,2.62,12.13-4.09,5.52-7.31-16.62-17.86-10.63,4,16.13,15.53,21S1021.76,273.8,1019.28,272.91Z"
            fill="url(#a02c409c-67ce-495b-bda2-817fa245c765)"
          />
        </g>
      </g>
      <g>
        <ellipse
          cx="458.94"
          cy="363.81"
          rx="26.66"
          ry="5.58"
          fill="url(#a5611989-0511-4b55-bed0-0a78d306b3ae)"
        />
        <g>
          <path
            d="M498.64,360.22a5.56,5.56,0,0,0,1.71-10.44c-4.76-2.37-11-3.39-16.51-1,16.26-7,24.58-15.48,13.94-23.22-8.52-6.19-21.68,16.25-24.77,16.25s1.55-9.29,8.51-17.8,6.19-15.48.78-17.8-14.71,1.55-17,25.54c0-3.87,1.55-27.86-4.65-25.54s-10.83,15.48-.77,29.41c-6.19,2.32-5.42-3.87-5.42-3.87s-3.09-23.22-13.93-18.58-7.74,17,0,24.77,7.74,12.39-2.32,7.74-14.71-15.48-24-4.64,16.26,24,31,24.77C455.8,366.33,484,362.41,498.64,360.22Z"
            fill="url(#b8ca95fb-2faa-4a58-9785-c3c6b820103e)"
          />
          <path
            d="M489.27,358.13c.55-4.4-7.69-8.8-14.29-3.3,9.89-8.8,12.09-15.95,7.14-15.95s-15.94,9.35-18.14,9.35,4.85-4.28,9.8-10.33,2.3-10.73-1.55-12.38c-3.6-1.55-14.55,1.93-17.36,16.31a2.5,2.5,0,0,1-1.72,1.9c-.85.28-1.81-2-1.81-2s-4.95-18.83-12.65-15.53-5.5,12.09,0,17.59,5.5,8.8-1.65,5.5-10.45-11-17-3.3,7.69,11.55,18.14,12.1S489.27,358.13,489.27,358.13Z"
            fill="url(#a5aae58d-a556-4676-9635-3db154f8013b)"
          />
          <path
            d="M470.06,364.29c-2.06-.74,6-2.38,12.72-6.39s5.81-9.32,2.74-12.18c-2.87-2.68-14.34-3.12-21.86,9.47a2.5,2.5,0,0,1-2.26,1.2c-.89,0-1-2.46-1-2.46s1.73-19.39-6.63-18.9-9.27,9.52-6,16.56,2.19,10.14-3.42,4.61-6.1-13.88-14.92-8.87,3.34,13.47,13,17.52S472.13,365,470.06,364.29Z"
            fill="url(#bdd149c0-a2fc-49bf-a74b-eaca2e88cc67)"
          />
        </g>
      </g>
      <g>
        <ellipse
          cx="502.02"
          cy="378.33"
          rx="18.39"
          ry="3.85"
          fill="url(#f1308ecb-15ec-4732-9e40-780695c6ff67)"
        />
        <g>
          <path
            d="M529.4,375.85a3.83,3.83,0,0,0,1.18-7.2,13.83,13.83,0,0,0-11.39-.72c11.21-4.8,16.95-10.67,9.61-16-5.87-4.27-14.94,11.21-17.08,11.21s1.07-6.41,5.87-12.28,4.27-10.68.54-12.28-10.14,1.07-11.75,17.62c0-2.67,1.07-19.22-3.2-17.62s-7.47,10.68-.53,20.29c-4.27,1.6-3.74-2.67-3.74-2.67s-2.13-16-9.61-12.81-5.33,11.74,0,17.08,5.34,8.54-1.6,5.34-10.14-10.68-16.55-3.21,11.21,16.55,21.36,17.08C499.86,380.06,519.27,377.36,529.4,375.85Z"
            fill="url(#f86b4de5-0b49-4021-bf3f-9b566d034893)"
          />
          <path
            d="M522.94,374.41c.38-3-5.31-6.07-9.86-2.28,6.83-6.07,8.34-11,4.93-11s-11,6.45-12.51,6.45,3.34-2.95,6.76-7.12,1.58-7.4-1.07-8.54c-2.49-1.07-10,1.33-12,11.25a1.73,1.73,0,0,1-1.18,1.31c-.59.19-1.25-1.35-1.25-1.35s-3.42-13-8.73-10.72-3.79,8.34,0,12.14,3.8,6.06-1.13,3.79-7.21-7.59-11.76-2.28,5.31,8,12.51,8.35S522.94,374.41,522.94,374.41Z"
            fill="url(#ba72bb04-1869-4c6e-a78f-0359a4e00738)"
          />
          <path
            d="M509.69,378.66c-1.42-.52,4.15-1.64,8.77-4.41s4-6.43,1.89-8.4-9.89-2.15-15.08,6.53a1.71,1.71,0,0,1-1.55.83c-.62,0-.72-1.7-.72-1.7s1.18-13.37-4.58-13S492,365,494.31,369.9s1.51,7-2.36,3.18-4.21-9.58-10.29-6.12,2.3,9.29,8.95,12.08S511.12,379.17,509.69,378.66Z"
            fill="url(#b3534e58-2a53-4b83-826b-3b0f989bf356)"
          />
        </g>
      </g>
      <g>
        <ellipse
          cx="422.52"
          cy="388.52"
          rx="18.39"
          ry="3.85"
          fill="url(#b85782f7-db5d-46e7-b746-d34a16fb7a55)"
        />
        <g>
          <path
            d="M449.9,386.05a3.83,3.83,0,0,0,1.19-7.2,13.83,13.83,0,0,0-11.39-.72c11.21-4.8,16.95-10.68,9.61-16-5.87-4.27-14.95,11.21-17.08,11.21s1.07-6.41,5.87-12.28,4.27-10.68.53-12.28-10.14,1.07-11.74,17.62c0-2.67,1.07-19.22-3.2-17.62s-7.48,10.68-.54,20.29c-4.27,1.6-3.73-2.67-3.73-2.67s-2.14-16-9.61-12.81-5.34,11.74,0,17.08,5.34,8.54-1.6,5.33-10.14-10.67-16.55-3.2,11.21,16.55,21.35,17.08C420.36,390.26,439.78,387.56,449.9,386.05Z"
            fill="url(#aff5729b-f6e3-4ba7-8f18-9de3145c9b3f)"
          />
          <path
            d="M443.44,384.6c.38-3-5.3-6.06-9.85-2.27,6.82-6.07,8.34-11,4.93-11s-11,6.45-12.52,6.45,3.35-2.95,6.76-7.12,1.59-7.41-1.07-8.54c-2.48-1.07-10,1.32-12,11.25a1.74,1.74,0,0,1-1.18,1.31c-.59.19-1.26-1.35-1.26-1.35s-3.41-13-8.72-10.72-3.79,8.34,0,12.13,3.79,6.07-1.14,3.8-7.2-7.59-11.75-2.28,5.31,8,12.51,8.34S443.44,384.6,443.44,384.6Z"
            fill="url(#f3e07513-7a7b-4bc8-924b-027c78fc0c32)"
          />
          <path
            d="M430.2,388.86c-1.43-.52,4.15-1.65,8.77-4.41s4-6.43,1.89-8.4-9.9-2.15-15.08,6.53a1.75,1.75,0,0,1-1.56.83c-.61,0-.72-1.7-.72-1.7s1.19-13.37-4.58-13-6.39,6.56-4.11,11.41,1.52,7-2.35,3.19-4.21-9.58-10.29-6.13,2.3,9.3,8.95,12.09S431.63,389.37,430.2,388.86Z"
            fill="url(#b25680a3-b9bb-4655-af99-1bb58993928f)"
          />
        </g>
      </g>
      <g>
        <path
          d="M1382.3,533.18c-.71-21.2,12.72-33.21,11.3-34.63s-2.82-6.36-12.72,0-14.13,61.49-2.82,101.77a129.26,129.26,0,0,1,4.86,36.34q5,.06,10,.07c.19-2.09.41-3.9.66-5.31C1395.72,619.4,1383,554.38,1382.3,533.18Z"
          fill="url(#a7f02a41-3870-4a7a-9e35-7717119f6877)"
        />
        <path
          d="M1371,519.05c-.71-21.2,12.72-33.22,11.31-34.63s-2.83-6.36-12.72,0-14.14,61.48-2.83,101.77a133,133,0,0,1,4.11,50.28c3.27.07,6.55.12,9.83.17.42-8.06.89-15.31,1.61-19.36C1384.42,605.27,1371.7,540.25,1371,519.05Z"
          fill="url(#aa9c4e56-004b-44bd-a148-c1eb6727bac3)"
        />
        <path
          d="M1393.6,509.86c-.7-21.2,12.73-33.22,11.31-34.63s-2.83-6.36-12.72,0-14.13,61.49-2.83,101.77c6.73,24,5.2,43.43,3,59.73h10.47c.56-11.44,1.09-23.07,2.07-28.64C1407,596.08,1394.31,531.06,1393.6,509.86Z"
          fill="url(#a3de26e2-a151-459d-b2b1-039290b7711a)"
        />
        <path
          d="M1359.68,502.09c-.71-21.21,12.72-33.22,11.31-34.63s-2.83-6.36-12.72,0-14.14,61.48-2.83,101.76c7.73,27.56,4.56,49.15,2,66.84,3.69.14,7.39.26,11.08.35.74-13.49,1.26-29.3,2.46-36.09C1373.11,588.31,1360.39,523.29,1359.68,502.09Z"
          fill="url(#a27c7b39-2736-4b1b-a903-13ef1e882e12)"
        />
        <path
          d="M1348.37,526.82c-.7-21.2,12.72-33.21,11.31-34.63s-2.83-6.36-12.72,0-14.13,61.49-2.83,101.77a129.42,129.42,0,0,1,4.72,41.71c3.24.17,6.47.31,9.71.43.31-4.57.67-8.46,1.12-11C1361.8,613,1349.08,548,1348.37,526.82Z"
          fill="url(#bfa30389-e8ec-43d6-93a8-96f62b09e5c8)"
        />
        <path
          d="M1325.76,526.82c-.71-21.2,12.72-33.21,11.31-34.63s-2.83-6.36-12.72,0-14.14,61.49-2.83,101.77a129.44,129.44,0,0,1,4.79,40.1c3.24.3,6.48.58,9.72.82.29-4,.62-7.48,1-9.82C1339.19,613,1326.47,548,1325.76,526.82Z"
          fill="url(#effd281a-20b0-46d0-b8d7-f0b246f9e9da)"
        />
        <path
          d="M1337.07,509.86c-.71-21.2,12.72-33.22,11.3-34.63s-2.82-6.36-12.72,0-14.13,61.49-2.82,101.77c6.47,23.07,5.3,42,3.24,57.88q5.15.38,10.29.66c.54-11,1.07-22.07,2-27.45C1350.49,596.08,1337.77,531.06,1337.07,509.86Z"
          fill="url(#ac832ae8-49b1-4ce3-b2d0-33e96cadb890)"
        />
        <path
          d="M1416.22,486.54c-.71-21.2,12.72-33.22,11.31-34.63s-2.83-6.36-12.72,0-14.14,61.48-2.83,101.77c10.27,36.57,1.31,62.66.1,83l11.78-.07c1.62-13.2,1.93-42,3.67-51.86C1429.65,572.76,1416.93,507.74,1416.22,486.54Z"
          fill="url(#ba856eb3-e8e0-4c41-a5e4-45def4629253)"
        />
        <path
          d="M1389.36,632.83s7.78,5.65,10.6,0,2.83-45.94,5-58-10.6-77-11.31-98.24,12.73-33.21,11.31-34.63-2.83-6.36-12.72,0-14.13,61.49-2.83,101.77S1388.66,611.63,1389.36,632.83Z"
          fill="url(#b7d05d11-e5fa-48af-830f-12ab8ff71955)"
        />
        <path
          d="M1355.44,632.83s7.77,5.65,10.6,0,2.83-45.94,5-58-10.6-77-11.31-98.24S1372.4,443.43,1371,442s-2.83-6.36-12.72,0-14.14,61.49-2.83,101.77S1354.73,611.63,1355.44,632.83Z"
          fill="url(#bab56b5d-0e07-4d06-b792-666361d801e4)"
        />
        <path
          d="M1325.76,505.62c-1.41-1.41-2.83-6.36-12.72,0s-14.14,61.48-2.83,101.77a129.1,129.1,0,0,1,4.51,25.46q5.63.66,11.27,1.19c-.3-18.89-10.9-74.49-11.54-93.79C1313.74,519.05,1327.17,507,1325.76,505.62Z"
          fill="url(#f28b40f5-c655-47b1-981b-f8b34d5294be)"
        />
        <path
          d="M1404.91,533.18c-.71-21.2,12.72-33.21,11.31-34.63s-2.83-6.36-12.72,0-14.14,61.49-2.83,101.77a128.63,128.63,0,0,1,4.86,36.41l10-.05c.19-2.07.41-3.86.66-5.26C1418.34,619.4,1405.62,554.38,1404.91,533.18Z"
          fill="url(#f8657fa6-e0d4-41a2-b96b-d715969e2776)"
        />
      </g>
      <g>
        <path
          d="M1270.49,556.74c-.54-16.23,9.74-25.42,8.66-26.51s-2.17-4.86-9.74,0-10.82,47.07-2.17,77.91A98.08,98.08,0,0,1,1271,636l7.67.06c.16-1.61.32-3,.52-4.07C1280.77,622.74,1271,573,1270.49,556.74Z"
          fill="url(#b71f52cd-d1f2-4949-b43e-e802a3543fe4)"
        />
        <path
          d="M1261.83,545.92c-.54-16.23,9.74-25.42,8.66-26.5s-2.16-4.87-9.74,0-10.82,47.06-2.16,77.9a101.67,101.67,0,0,1,3.14,38.48q3.76.09,7.53.13c.32-6.16.68-11.71,1.23-14.81C1272.11,611.92,1262.38,562.15,1261.83,545.92Z"
          fill="url(#ad4e2c12-31fc-42bf-b173-285ed5b53183)"
        />
        <path
          d="M1279.15,538.89c-.55-16.23,9.73-25.43,8.65-26.51s-2.16-4.87-9.74,0-10.82,47.07-2.16,77.9c5.15,18.35,4,33.25,2.3,45.72h8c.44-8.76.84-17.66,1.59-21.92C1289.42,604.89,1279.69,555.12,1279.15,538.89Z"
          fill="url(#f7f33685-4afb-4778-b168-984702ef330e)"
        />
        <path
          d="M1253.18,532.94c-.54-16.23,9.74-25.43,8.65-26.51s-2.16-4.87-9.73,0-10.82,47.07-2.17,77.9c5.92,21.09,3.49,37.62,1.54,51.16q4.24.16,8.48.27c.57-10.33,1-22.43,1.88-27.62C1263.46,598.94,1253.72,549.17,1253.18,532.94Z"
          fill="url(#f6ccfa80-6d7b-4ed9-9262-350f67911d2b)"
        />
        <path
          d="M1244.52,551.87c-.54-16.23,9.74-25.42,8.66-26.5s-2.17-4.87-9.74,0-10.82,47.06-2.16,77.9a99.45,99.45,0,0,1,3.61,31.93c2.48.12,4.95.23,7.43.33.24-3.5.51-6.48.86-8.46C1254.8,617.87,1245.06,568.1,1244.52,551.87Z"
          fill="url(#a433ceab-9ce5-4cf7-81ab-72bb9c9b498e)"
        />
        <path
          d="M1227.21,551.87c-.54-16.23,9.74-25.42,8.66-26.5s-2.17-4.87-9.74,0-10.82,47.06-2.16,77.9a98.93,98.93,0,0,1,3.66,30.7c2.48.22,5,.44,7.44.62.23-3.1.48-5.72.8-7.52C1237.49,617.87,1227.75,568.1,1227.21,551.87Z"
          fill="url(#ef4e82e5-acbf-4541-9921-d8f98d09728e)"
        />
        <path
          d="M1235.87,538.89c-.54-16.23,9.74-25.43,8.65-26.51s-2.16-4.87-9.73,0-10.82,47.07-2.17,77.9c5,17.66,4.06,32.12,2.49,44.31,2.62.19,5.25.36,7.87.5.42-8.46.82-16.89,1.54-21C1246.15,604.89,1236.41,555.12,1235.87,538.89Z"
          fill="url(#f4501b39-a116-43df-ab53-3c3bbeb13744)"
        />
        <path
          d="M1296.46,521c-.54-16.23,9.73-25.43,8.65-26.51s-2.16-4.87-9.74,0-10.81,47.07-2.16,77.9c7.86,28,1,48,.08,63.55l9-.05c1.23-10.11,1.47-32.16,2.8-39.7C1306.74,587,1297,537.27,1296.46,521Z"
          fill="url(#b4c1056e-f7c8-4d05-abe0-e86918a3a86d)"
        />
        <path
          d="M1275.9,633s5.95,4.33,8.11,0,2.17-35.16,3.79-44.36-8.11-59-8.65-75.2,9.73-25.42,8.65-26.5-2.16-4.87-9.74,0-10.82,47.06-2.16,77.9S1275.36,616.79,1275.9,633Z"
          fill="url(#b65d23e6-4a65-4f20-a00c-6147d1758584)"
        />
        <path
          d="M1249.93,633s6,4.33,8.12,0,2.16-35.16,3.78-44.36-8.11-59-8.65-75.2,9.74-25.42,8.65-26.5-2.16-4.87-9.73,0-10.82,47.06-2.17,77.9S1249.39,616.79,1249.93,633Z"
          fill="url(#b9e2654c-2061-45ad-80ca-2fa3e01ed5f1)"
        />
        <path
          d="M1227.21,535.64c-1.08-1.08-2.16-4.86-9.74,0s-10.82,47.07-2.16,77.9a98.88,98.88,0,0,1,3.45,19.49c2.87.34,5.75.65,8.63.91-.23-14.45-8.34-57-8.83-71.79C1218,545.92,1228.29,536.73,1227.21,535.64Z"
          fill="url(#ed32a6d6-a8cd-48d5-a958-63bf2b340e89)"
        />
        <path
          d="M1287.8,556.74c-.54-16.23,9.74-25.42,8.66-26.51s-2.17-4.86-9.74,0-10.82,47.07-2.16,77.91a99.13,99.13,0,0,1,3.72,27.86l7.67,0c.15-1.59.32-3,.51-4C1298.08,622.74,1288.34,573,1287.8,556.74Z"
          fill="url(#a6dbe83d-9c0c-4ea0-aa89-193e0d18b980)"
        />
      </g>
      <g className="coins" transform="translate(65 70)">
        <g>
          <path
            d="M131.23,180.36,111.08,105s31.6-10.72,21.53-49.06c3.13,1.65,8.71,3,8.39.08s-6.57-6.55-7.1-21.79c-1.74-.66-7-3-10.93,8S129.08,89.91,108,96.52C102,70.2,93.69,33.17,93.69,33.17s9.1-.88,9.83-2.82S86.36,0,82.17,0s-8,31.36-6,34.3,7.7-.25,7.7-.25L97.51,98.36s-11.93,3.78-22.53-18S57.56,42.55,49.51,43.45c-1.51,9.71-1,23-2.75,26.55,4.91-.93,9.19-8,9.2-9.31,1,5.84,14.1,53,41.46,46.1l15.71,65.62Z"
            fill="#ffaf00"
          />
          <path
            d="M134.25,34.21c-1.74-.67-7-3-10.93,8s6.11,47.7-14.94,54.31"
            fill="none"
            stroke="#d69000"
            strokeMiterlimit="10"
            strokeWidth="2.69"
          />
          <line
            x1="99.17"
            y1="106.8"
            x2="114.88"
            y2="172.43"
            fill="none"
            stroke="#d69000"
            strokeMiterlimit="10"
            strokeWidth="2.69"
          />
          <path
            d="M46.76,70c4.91-.93,9.19-8,9.2-9.31,1,5.84,14.1,53,41.46,46.1"
            fill="none"
            stroke="#d69000"
            strokeMiterlimit="10"
            strokeWidth="2.69"
          />
          <path
            d="M76.9,33c2.07,2.94,7.7-.25,7.7-.25L98.23,97.07"
            fill="none"
            stroke="#d69000"
            strokeMiterlimit="10"
            strokeWidth="2.69"
          />
          <path
            d="M130.7,39.36s-2.22,10.35,3.36,12"
            fill="none"
            stroke="#f2e2c4"
            strokeMiterlimit="10"
            strokeWidth="2.69"
          />
          <path
            d="M84.54,6.51s6.6,4.6,10,17.27"
            fill="none"
            stroke="#f2e2c4"
            strokeMiterlimit="10"
            strokeWidth="2.69"
          />
          <path
            d="M52.26,47.69s9,7.21,13.73,23.14"
            fill="none"
            stroke="#f2e2c4"
            strokeMiterlimit="10"
            strokeWidth="2.69"
          />
        </g>
        <g>
          <polygon
            points="158.91 253.07 172.3 253.55 181.59 272.34 161.5 264.6 158.91 253.07"
            fill="#e20c49"
          />
          <polyline
            points="172.23 259.49 170.33 255.87 162.57 255.8"
            fill="none"
            stroke="#f2e2e8"
            strokeMiterlimit="10"
            strokeWidth="1.12"
          />
        </g>
        <g>
          <polygon
            points="93.89 280.09 82.53 287.74 64.51 278.15 85.41 272.32 93.89 280.09"
            fill="#1ee00e"
          />
          <polyline
            points="79.33 282.91 82.89 284.69 89.36 280.08"
            fill="none"
            stroke="#f2e2e8"
            strokeMiterlimit="10"
            strokeWidth="1.12"
          />
        </g>
        <g>
          <ellipse
            cx="113.12"
            cy="239.26"
            rx="2.26"
            ry="7.46"
            transform="translate(-127.19 350.13) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="120.59 238.2 120.57 239.33 105.66 239.19 105.68 238.06 120.59 238.2"
            fill="#d1a11e"
          />
          <ellipse
            cx="113.13"
            cy="238.13"
            rx="2.26"
            ry="7.46"
            transform="translate(-126.05 349.02) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="138.11"
            cy="235.98"
            rx="3.91"
            ry="12.91"
            transform="translate(-99.15 371.87) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="151.04 234.15 151.02 236.1 125.21 235.85 125.23 233.9 151.04 234.15"
            fill="#d1a11e"
          />
          <ellipse
            cx="138.13"
            cy="234.03"
            rx="3.91"
            ry="12.91"
            transform="translate(-97.18 369.95) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="125.19"
            cy="229.15"
            rx="3.91"
            ry="12.91"
            transform="translate(-105.12 352.19) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="138.12 227.32 138.1 229.27 112.29 229.03 112.31 227.07 138.12 227.32"
            fill="#d1a11e"
          />
          <ellipse
            cx="125.22"
            cy="227.2"
            rx="3.91"
            ry="12.91"
            transform="translate(-103.15 350.27) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="115.39"
            cy="216.56"
            rx="3.91"
            ry="12.91"
            transform="matrix(0.01, -1, 1, 0.01, -102.25, 329.92)"
            fill="#d1a11e"
          />
          <polygon
            points="128.32 214.74 128.3 216.69 102.49 216.44 102.51 214.49 128.32 214.74"
            fill="#d1a11e"
          />
          <ellipse
            cx="115.41"
            cy="214.61"
            rx="3.91"
            ry="12.91"
            transform="translate(-100.27 328.01) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="142.18"
            cy="218.43"
            rx="3.91"
            ry="12.91"
            transform="translate(-77.57 358.55) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="155.11 216.6 155.09 218.55 129.28 218.3 129.3 216.35 155.11 216.6"
            fill="#d1a11e"
          />
          <ellipse
            cx="142.21"
            cy="216.47"
            rx="3.91"
            ry="12.91"
            transform="translate(-75.59 356.64) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="156.37"
            cy="228.05"
            rx="3.91"
            ry="12.91"
            transform="translate(-73.14 382.27) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="169.3 226.22 169.28 228.17 143.46 227.93 143.49 225.97 169.3 226.22"
            fill="#d1a11e"
          />
          <ellipse
            cx="156.39"
            cy="226.1"
            rx="3.91"
            ry="12.91"
            transform="translate(-71.17 380.36) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="166.72"
            cy="216.07"
            rx="3.91"
            ry="12.91"
            transform="matrix(0.01, -1, 1, 0.01, -50.91, 380.75)"
            fill="#d1a11e"
          />
          <polygon
            points="179.65 214.24 179.62 216.19 153.81 215.95 153.83 213.99 179.65 214.24"
            fill="#d1a11e"
          />
          <ellipse
            cx="166.74"
            cy="214.12"
            rx="3.91"
            ry="12.91"
            transform="translate(-48.93 378.84) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="159.03"
            cy="226.95"
            rx="3.91"
            ry="12.91"
            transform="translate(-69.4 383.85) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="171.96 225.12 171.94 227.07 146.13 226.83 146.15 224.88 171.96 225.12"
            fill="#d1a11e"
          />
          <ellipse
            cx="159.06"
            cy="225"
            rx="3.91"
            ry="12.91"
            transform="translate(-67.43 381.93) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="138.21"
            cy="225.78"
            rx="3.91"
            ry="12.91"
            transform="translate(-88.86 361.86) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="151.14 223.95 151.12 225.9 125.3 225.66 125.33 223.7 151.14 223.95"
            fill="#d1a11e"
          />
          <ellipse
            cx="138.23"
            cy="223.83"
            rx="3.91"
            ry="12.91"
            transform="translate(-86.88 359.95) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="125.37"
            cy="210.72"
            rx="3.91"
            ry="12.91"
            transform="matrix(0.01, -1, 1, 0.01, -86.52, 334.1)"
            fill="#d1a11e"
          />
          <polygon
            points="138.3 208.89 138.28 210.84 112.46 210.59 112.48 208.64 138.3 208.89"
            fill="#d1a11e"
          />
          <ellipse
            cx="125.39"
            cy="208.76"
            rx="3.91"
            ry="12.91"
            transform="translate(-84.54 332.19) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="101.54"
            cy="226.56"
            rx="3.91"
            ry="12.91"
            transform="translate(-125.96 325.97) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="114.47 224.73 114.45 226.68 88.64 226.44 88.66 224.48 114.47 224.73"
            fill="#d1a11e"
          />
          <ellipse
            cx="101.57"
            cy="224.61"
            rx="3.91"
            ry="12.91"
            transform="translate(-123.98 324.06) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="105.65"
            cy="230.25"
            rx="3.91"
            ry="12.91"
            transform="translate(-125.58 333.74) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="118.58 228.42 118.56 230.37 92.75 230.13 92.77 228.17 118.58 228.42"
            fill="#d1a11e"
          />
          <ellipse
            cx="105.67"
            cy="228.3"
            rx="3.91"
            ry="12.91"
            transform="translate(-123.6 331.82) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="151.03"
            cy="276.05"
            rx="3.91"
            ry="12.91"
            transform="translate(-126.43 424.48) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="163.96 274.22 163.93 276.17 138.12 275.93 138.14 273.98 163.96 274.22"
            fill="#d1a11e"
          />
          <ellipse
            cx="151.05"
            cy="274.1"
            rx="3.91"
            ry="12.91"
            transform="translate(-124.45 422.57) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="196.51"
            cy="230.13"
            rx="3.91"
            ry="12.91"
            transform="translate(-35.45 424.47) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="209.44 228.3 209.42 230.25 183.6 230 183.63 228.05 209.44 228.3"
            fill="#d1a11e"
          />
          <ellipse
            cx="196.53"
            cy="228.17"
            rx="3.91"
            ry="12.91"
            transform="translate(-33.48 422.55) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="229.85"
            cy="235.86"
            rx="3.91"
            ry="12.91"
            transform="translate(-8.16 463.49) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="242.78 234.03 242.76 235.99 216.95 235.74 216.97 233.79 242.78 234.03"
            fill="#d1a11e"
          />
          <ellipse
            cx="229.88"
            cy="233.91"
            rx="3.91"
            ry="12.91"
            transform="translate(-6.18 461.58) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="221.06"
            cy="224.68"
            rx="3.91"
            ry="12.91"
            transform="matrix(0.01, -1, 1, 0.01, -5.68, 443.62)"
            fill="#d1a11e"
          />
          <polygon
            points="233.99 222.85 233.97 224.8 208.16 224.56 208.18 222.6 233.99 222.85"
            fill="#d1a11e"
          />
          <ellipse
            cx="221.09"
            cy="222.73"
            rx="3.91"
            ry="12.91"
            transform="translate(-3.71 441.71) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="208.15"
            cy="246.25"
            rx="3.91"
            ry="12.91"
            transform="translate(-40.05 452.08) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="221.07 244.43 221.05 246.38 195.24 246.13 195.26 244.18 221.07 244.43"
            fill="#d1a11e"
          />
          <ellipse
            cx="208.17"
            cy="244.3"
            rx="3.91"
            ry="12.91"
            transform="translate(-38.08 450.17) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="190.05"
            cy="224.8"
            rx="3.91"
            ry="12.91"
            transform="translate(-36.53 412.73) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="202.98 222.97 202.95 224.93 177.14 224.68 177.16 222.73 202.98 222.97"
            fill="#d1a11e"
          />
          <ellipse
            cx="190.07"
            cy="222.85"
            rx="3.91"
            ry="12.91"
            transform="translate(-34.55 410.82) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="194.28"
            cy="210.39"
            rx="3.91"
            ry="12.91"
            transform="matrix(0.01, -1, 1, 0.01, -17.92, 402.69)"
            fill="#d1a11e"
          />
          <polygon
            points="207.21 208.56 207.19 210.51 181.38 210.26 181.4 208.31 207.21 208.56"
            fill="#d1a11e"
          />
          <ellipse
            cx="194.31"
            cy="208.44"
            rx="3.91"
            ry="12.91"
            transform="matrix(0.01, -1, 1, 0.01, -15.95, 400.78)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="187.21"
            cy="235.98"
            rx="3.91"
            ry="12.91"
            transform="matrix(0.01, -1, 1, 0.01, -50.51, 420.97)"
            fill="#d1a11e"
          />
          <polygon
            points="200.14 234.15 200.12 236.1 174.31 235.85 174.33 233.9 200.14 234.15"
            fill="#d1a11e"
          />
          <ellipse
            cx="187.24"
            cy="234.03"
            rx="3.91"
            ry="12.91"
            transform="translate(-48.54 419.06) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="151.13"
            cy="204.09"
            rx="3.91"
            ry="12.91"
            transform="translate(-54.37 353.29) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="164.05 202.26 164.03 204.21 138.22 203.97 138.24 202.01 164.05 202.26"
            fill="#d1a11e"
          />
          <ellipse
            cx="151.15"
            cy="202.14"
            rx="3.91"
            ry="12.91"
            transform="translate(-52.4 351.38) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="105.64"
            cy="205.19"
            rx="3.91"
            ry="12.91"
            transform="translate(-100.53 308.9) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="118.57 203.36 118.55 205.31 92.74 205.06 92.76 203.11 118.57 203.36"
            fill="#d1a11e"
          />
          <ellipse
            cx="105.66"
            cy="203.24"
            rx="3.91"
            ry="12.91"
            transform="translate(-98.56 306.99) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="89.35"
            cy="219.86"
            rx="3.91"
            ry="12.91"
            transform="translate(-131.34 307.14) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="102.28 218.03 102.25 219.99 76.44 219.74 76.47 217.79 102.28 218.03"
            fill="#d1a11e"
          />
          <ellipse
            cx="89.37"
            cy="217.91"
            rx="3.91"
            ry="12.91"
            transform="translate(-129.37 305.23) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="84.33"
            cy="202.44"
            rx="3.91"
            ry="12.91"
            transform="translate(-118.89 284.87) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="97.26 200.61 97.24 202.56 71.43 202.32 71.45 200.37 97.26 200.61"
            fill="#d1a11e"
          />
          <ellipse
            cx="84.36"
            cy="200.49"
            rx="3.91"
            ry="12.91"
            transform="translate(-116.92 282.96) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="129.27"
            cy="194.51"
            rx="3.91"
            ry="12.91"
            transform="translate(-66.45 321.94) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="142.2 192.68 142.17 194.63 116.36 194.38 116.38 192.43 142.2 192.68"
            fill="#d1a11e"
          />
          <ellipse
            cx="129.29"
            cy="192.56"
            rx="3.91"
            ry="12.91"
            transform="translate(-64.47 320.03) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="174.3"
            cy="201.34"
            rx="3.91"
            ry="12.91"
            transform="translate(-28.67 373.74) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="187.22 199.51 187.2 201.47 161.39 201.22 161.41 199.27 187.22 199.51"
            fill="#d1a11e"
          />
          <ellipse
            cx="174.32"
            cy="199.39"
            rx="3.91"
            ry="12.91"
            transform="translate(-26.7 371.83) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="183.16"
            cy="217.66"
            rx="3.91"
            ry="12.91"
            transform="translate(-36.21 398.77) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="196.09 215.83 196.07 217.79 170.25 217.54 170.28 215.59 196.09 215.83"
            fill="#d1a11e"
          />
          <ellipse
            cx="183.18"
            cy="215.71"
            rx="3.91"
            ry="12.91"
            transform="translate(-34.24 396.86) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="153.8"
            cy="206.62"
            rx="3.91"
            ry="12.91"
            transform="translate(-54.25 358.47) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="166.73 204.79 166.71 206.74 140.9 206.49 140.92 204.54 166.73 204.79"
            fill="#d1a11e"
          />
          <ellipse
            cx="153.82"
            cy="204.66"
            rx="3.91"
            ry="12.91"
            transform="translate(-52.28 356.56) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="137.99"
            cy="203.11"
            rx="3.91"
            ry="12.91"
            transform="translate(-66.41 339.19) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="150.92 201.28 150.9 203.24 125.08 202.99 125.11 201.04 150.92 201.28"
            fill="#d1a11e"
          />
          <ellipse
            cx="138.01"
            cy="201.16"
            rx="3.91"
            ry="12.91"
            transform="translate(-64.44 337.28) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="112.28"
            cy="193.37"
            rx="3.91"
            ry="12.91"
            transform="translate(-82.14 303.83) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="125.21 191.54 125.18 193.5 99.37 193.25 99.39 191.3 125.21 191.54"
            fill="#d1a11e"
          />
          <ellipse
            cx="112.3"
            cy="191.42"
            rx="3.91"
            ry="12.91"
            transform="translate(-80.17 301.92) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="150.91"
            cy="182.4"
            rx="3.91"
            ry="12.91"
            transform="matrix(0.01, -1, 1, 0.01, -32.9, 331.59)"
            fill="#d1a11e"
          />
          <polygon
            points="163.83 180.57 163.81 182.52 138 182.28 138.02 180.32 163.83 180.57"
            fill="#d1a11e"
          />
          <ellipse
            cx="150.93"
            cy="180.45"
            rx="3.91"
            ry="12.91"
            transform="translate(-30.93 329.67) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="152.41"
            cy="195.48"
            rx="3.91"
            ry="12.91"
            transform="translate(-44.49 346.06) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="165.34 193.66 165.32 195.61 139.51 195.36 139.53 193.41 165.34 193.66"
            fill="#d1a11e"
          />
          <ellipse
            cx="152.44"
            cy="193.53"
            rx="3.91"
            ry="12.91"
            transform="matrix(0.01, -1, 1, 0.01, -42.52, 344.14)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="214.96"
            cy="214.97"
            rx="3.91"
            ry="12.91"
            transform="translate(-2.02 427.9) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="227.89 213.14 227.86 215.09 202.05 214.85 202.07 212.89 227.89 213.14"
            fill="#d1a11e"
          />
          <ellipse
            cx="214.98"
            cy="213.02"
            rx="3.91"
            ry="12.91"
            transform="translate(-0.05 425.99) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="208.14"
            cy="200.24"
            rx="3.91"
            ry="12.91"
            transform="translate(5.95 406.49) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="221.06 198.41 221.04 200.37 195.23 200.12 195.25 198.17 221.06 198.41"
            fill="#d1a11e"
          />
          <ellipse
            cx="208.16"
            cy="198.29"
            rx="3.91"
            ry="12.91"
            transform="translate(7.92 404.58) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="187.2"
            cy="196.79"
            rx="3.91"
            ry="12.91"
            transform="translate(-11.33 382.13) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="200.13 194.96 200.11 196.91 174.3 196.66 174.32 194.71 200.13 194.96"
            fill="#d1a11e"
          />
          <ellipse
            cx="187.22"
            cy="194.84"
            rx="3.91"
            ry="12.91"
            transform="translate(-9.36 380.22) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="178.06"
            cy="186.61"
            rx="3.91"
            ry="12.91"
            transform="translate(-10.22 362.91) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="190.99 184.78 190.96 186.74 165.15 186.49 165.17 184.54 190.99 184.78"
            fill="#d1a11e"
          />
          <ellipse
            cx="178.08"
            cy="184.66"
            rx="3.91"
            ry="12.91"
            transform="translate(-8.25 361) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="125.07"
            cy="180.78"
            rx="3.91"
            ry="12.91"
            transform="translate(-56.87 304.15) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="138 178.95 137.98 180.9 112.17 180.65 112.19 178.7 138 178.95"
            fill="#d1a11e"
          />
          <ellipse
            cx="125.09"
            cy="178.82"
            rx="3.91"
            ry="12.91"
            transform="translate(-54.9 302.23) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="113.02"
            cy="183.56"
            rx="3.91"
            ry="12.91"
            transform="translate(-71.6 294.85) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="125.95 181.73 125.92 183.68 100.11 183.44 100.13 181.49 125.95 181.73"
            fill="#d1a11e"
          />
          <ellipse
            cx="113.04"
            cy="181.61"
            rx="3.91"
            ry="12.91"
            transform="translate(-69.62 292.94) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="115.38"
            cy="174.39"
            rx="3.91"
            ry="12.91"
            transform="matrix(0.01, -1, 1, 0.01, -60.08, 288.13)"
            fill="#d1a11e"
          />
          <polygon
            points="128.31 172.56 128.29 174.51 102.48 174.27 102.5 172.31 128.31 172.56"
            fill="#d1a11e"
          />
          <ellipse
            cx="115.4"
            cy="172.44"
            rx="3.91"
            ry="12.91"
            transform="translate(-58.11 286.22) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="89.61"
            cy="192.18"
            rx="3.91"
            ry="12.91"
            transform="translate(-103.41 279.99) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="102.54 190.35 102.52 192.31 76.7 192.06 76.73 190.11 102.54 190.35"
            fill="#d1a11e"
          />
          <ellipse
            cx="89.63"
            cy="190.23"
            rx="3.91"
            ry="12.91"
            transform="translate(-101.43 278.07) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="87.91"
            cy="246.1"
            rx="3.91"
            ry="12.91"
            transform="translate(-159.01 331.69) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="100.83 244.27 100.81 246.22 75 245.98 75.02 244.03 100.83 244.27"
            fill="#d1a11e"
          />
          <ellipse
            cx="87.93"
            cy="244.15"
            rx="3.91"
            ry="12.91"
            transform="translate(-157.04 329.78) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="54.73"
            cy="264.66"
            rx="3.91"
            ry="12.91"
            transform="translate(-210.43 316.9) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="67.66 262.83 67.64 264.78 41.83 264.54 41.85 262.58 67.66 262.83"
            fill="#d1a11e"
          />
          <ellipse
            cx="54.75"
            cy="262.71"
            rx="3.91"
            ry="12.91"
            transform="translate(-208.45 314.99) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="40.13"
            cy="206.62"
            rx="3.91"
            ry="12.91"
            transform="translate(-166.86 244.8) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="53.05 204.79 53.03 206.74 27.22 206.49 27.24 204.54 53.05 204.79"
            fill="#d1a11e"
          />
          <ellipse
            cx="40.15"
            cy="204.66"
            rx="3.91"
            ry="12.91"
            transform="translate(-164.88 242.89) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="55.41"
            cy="192.18"
            rx="3.91"
            ry="12.91"
            transform="translate(-137.28 245.79) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="68.34 190.35 68.32 192.31 42.51 192.06 42.53 190.11 68.34 190.35"
            fill="#d1a11e"
          />
          <ellipse
            cx="55.44"
            cy="190.23"
            rx="3.91"
            ry="12.91"
            transform="translate(-135.31 243.88) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="138.12"
            cy="188.82"
            rx="3.91"
            ry="12.91"
            transform="translate(-51.99 325.17) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="151.05 186.99 151.03 188.95 125.22 188.7 125.24 186.75 151.05 186.99"
            fill="#d1a11e"
          />
          <ellipse
            cx="138.14"
            cy="186.87"
            rx="3.91"
            ry="12.91"
            transform="translate(-50.02 323.25) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="165.33"
            cy="189.8"
            rx="3.91"
            ry="12.91"
            transform="translate(-26.01 353.34) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="178.26 187.97 178.24 189.92 152.43 189.68 152.45 187.72 178.26 187.97"
            fill="#d1a11e"
          />
          <ellipse
            cx="165.35"
            cy="187.85"
            rx="3.91"
            ry="12.91"
            transform="translate(-24.04 351.43) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="105.63"
            cy="187.54"
            rx="3.91"
            ry="12.91"
            transform="translate(-82.89 291.41) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="118.56 185.71 118.54 187.66 92.72 187.42 92.75 185.47 118.56 185.71"
            fill="#d1a11e"
          />
          <ellipse
            cx="105.65"
            cy="185.59"
            rx="3.91"
            ry="12.91"
            transform="translate(-80.92 289.49) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="96.51"
            cy="212.13"
            rx="3.91"
            ry="12.91"
            transform="matrix(0.01, -1, 1, 0.01, -116.52, 306.64)"
            fill="#d1a11e"
          />
          <polygon
            points="109.44 210.3 109.42 212.25 83.6 212 83.63 210.05 109.44 210.3"
            fill="#d1a11e"
          />
          <ellipse
            cx="96.53"
            cy="210.18"
            rx="3.91"
            ry="12.91"
            transform="translate(-114.54 304.73) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="166.73"
            cy="219.86"
            rx="3.91"
            ry="12.91"
            transform="translate(-54.69 384.52) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="179.66 218.03 179.63 219.99 153.82 219.74 153.84 217.79 179.66 218.03"
            fill="#d1a11e"
          />
          <ellipse
            cx="166.75"
            cy="217.91"
            rx="3.91"
            ry="12.91"
            transform="translate(-52.72 382.61) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="173.06"
            cy="208.33"
            rx="3.91"
            ry="12.91"
            transform="translate(-36.88 379.42) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="185.99 206.5 185.97 208.45 160.16 208.2 160.18 206.25 185.99 206.5"
            fill="#d1a11e"
          />
          <ellipse
            cx="173.08"
            cy="206.37"
            rx="3.91"
            ry="12.91"
            transform="matrix(0.01, -1, 1, 0.01, -34.9, 377.51)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="118.25"
            cy="222.48"
            rx="3.91"
            ry="12.91"
            transform="translate(-105.33 338.63) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="131.18 220.65 131.16 222.6 105.34 222.36 105.36 220.4 131.18 220.65"
            fill="#d1a11e"
          />
          <ellipse
            cx="118.27"
            cy="220.53"
            rx="3.91"
            ry="12.91"
            transform="translate(-103.36 336.72) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="146.5"
            cy="213.23"
            rx="3.91"
            ry="12.91"
            transform="matrix(0.01, -1, 1, 0.01, -68.1, 357.72)"
            fill="#d1a11e"
          />
          <polygon
            points="159.42 211.4 159.4 213.35 133.59 213.1 133.61 211.15 159.42 211.4"
            fill="#d1a11e"
          />
          <ellipse
            cx="146.52"
            cy="211.28"
            rx="3.91"
            ry="12.91"
            transform="translate(-66.12 355.8) rotate(-89.46)"
            fill="#f4b11c"
          />
        </g>
        <g>
          <ellipse
            cx="116.35"
            cy="199.14"
            rx="3.91"
            ry="12.91"
            transform="translate(-83.87 313.62) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="129.28 197.31 129.26 199.27 103.44 199.02 103.47 197.07 129.28 197.31"
            fill="#d1a11e"
          />
          <ellipse
            cx="116.37"
            cy="197.19"
            rx="3.91"
            ry="12.91"
            transform="translate(-81.9 311.71) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="209.44"
            cy="236.65"
            rx="3.91"
            ry="12.91"
            transform="translate(-29.17 443.85) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="222.37 234.82 222.34 236.77 196.53 236.53 196.55 234.57 222.37 234.82"
            fill="#d1a11e"
          />
          <ellipse
            cx="209.46"
            cy="234.7"
            rx="3.91"
            ry="12.91"
            transform="translate(-27.19 441.94) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="234.79"
            cy="219.53"
            rx="3.91"
            ry="12.91"
            transform="translate(13.07 452.25) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="247.72 217.7 247.7 219.65 221.89 219.4 221.91 217.45 247.72 217.7"
            fill="#d1a11e"
          />
          <ellipse
            cx="234.82"
            cy="217.57"
            rx="3.91"
            ry="12.91"
            transform="matrix(0.01, -1, 1, 0.01, 15.05, 450.34)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="218.91"
            cy="207.78"
            rx="3.91"
            ry="12.91"
            transform="translate(9.08 424.73) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="231.84 205.95 231.81 207.9 206 207.66 206.02 205.7 231.84 205.95"
            fill="#d1a11e"
          />
          <ellipse
            cx="218.93"
            cy="205.83"
            rx="3.91"
            ry="12.91"
            transform="translate(11.06 422.81) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="196.08"
            cy="204.21"
            rx="3.91"
            ry="12.91"
            transform="translate(-9.97 398.36) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="209 202.38 208.98 204.34 183.17 204.09 183.19 202.14 209 202.38"
            fill="#d1a11e"
          />
          <ellipse
            cx="196.1"
            cy="202.26"
            rx="3.91"
            ry="12.91"
            transform="translate(-7.99 396.45) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="192.39"
            cy="189.8"
            rx="3.91"
            ry="12.91"
            transform="translate(0.8 380.4) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="205.32 187.97 205.3 189.92 179.49 189.68 179.51 187.72 205.32 187.97"
            fill="#d1a11e"
          />
          <ellipse
            cx="192.41"
            cy="187.85"
            rx="3.91"
            ry="12.91"
            transform="translate(2.77 378.49) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="84.34"
            cy="211.67"
            rx="3.91"
            ry="12.91"
            transform="translate(-128.11 294.02) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="97.27 209.84 97.25 211.79 71.44 211.54 71.46 209.59 97.27 209.84"
            fill="#d1a11e"
          />
          <ellipse
            cx="84.37"
            cy="209.72"
            rx="3.91"
            ry="12.91"
            transform="translate(-126.13 292.11) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="97.26"
            cy="238.26"
            rx="3.91"
            ry="12.91"
            transform="translate(-141.9 333.28) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="110.19 236.43 110.17 238.38 84.36 238.13 84.38 236.18 110.19 236.43"
            fill="#d1a11e"
          />
          <ellipse
            cx="97.28"
            cy="236.3"
            rx="3.91"
            ry="12.91"
            transform="translate(-139.93 331.36) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="131.17"
            cy="245.53"
            rx="3.91"
            ry="12.91"
            transform="translate(-115.59 374.39) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="144.09 243.7 144.07 245.66 118.26 245.41 118.28 243.46 144.09 243.7"
            fill="#d1a11e"
          />
          <ellipse
            cx="131.19"
            cy="243.58"
            rx="3.91"
            ry="12.91"
            transform="translate(-113.61 372.47) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="68.33"
            cy="222.27"
            rx="3.91"
            ry="12.91"
            transform="translate(-154.57 288.51) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="81.26 220.44 81.24 222.39 55.42 222.15 55.45 220.19 81.26 220.44"
            fill="#d1a11e"
          />
          <ellipse
            cx="68.35"
            cy="220.32"
            rx="3.91"
            ry="12.91"
            transform="translate(-152.59 286.6) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="238.78"
            cy="243.8"
            rx="3.91"
            ry="12.91"
            transform="translate(-7.26 480.28) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="251.7 241.97 251.68 243.93 225.87 243.68 225.89 241.73 251.7 241.97"
            fill="#d1a11e"
          />
          <ellipse
            cx="238.8"
            cy="241.85"
            rx="3.91"
            ry="12.91"
            transform="translate(-5.29 478.37) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="212"
            cy="231.04"
            rx="3.91"
            ry="12.91"
            transform="matrix(0.01, -1, 1, 0.01, -21.02, 440.86)"
            fill="#d1a11e"
          />
          <polygon
            points="224.93 229.21 224.91 231.16 199.09 230.91 199.12 228.96 224.93 229.21"
            fill="#d1a11e"
          />
          <ellipse
            cx="212.02"
            cy="229.08"
            rx="3.91"
            ry="12.91"
            transform="translate(-19.04 438.95) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="205.31"
            cy="220.5"
            rx="3.91"
            ry="12.91"
            transform="matrix(0.01, -1, 1, 0.01, -17.11, 423.73)"
            fill="#d1a11e"
          />
          <polygon
            points="218.24 218.67 218.22 220.63 192.4 220.38 192.43 218.43 218.24 218.67"
            fill="#d1a11e"
          />
          <ellipse
            cx="205.33"
            cy="218.55"
            rx="3.91"
            ry="12.91"
            transform="translate(-15.14 421.82) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="168.69"
            cy="196.79"
            rx="3.91"
            ry="12.91"
            transform="translate(-29.67 363.63) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="181.62 194.96 181.6 196.91 155.79 196.66 155.81 194.71 181.62 194.96"
            fill="#d1a11e"
          />
          <ellipse
            cx="168.72"
            cy="194.84"
            rx="3.91"
            ry="12.91"
            transform="translate(-27.7 361.71) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="179.63"
            cy="193.85"
            rx="3.91"
            ry="12.91"
            transform="translate(-15.9 371.66) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="192.56 192.03 192.54 193.98 166.73 193.73 166.75 191.78 192.56 192.03"
            fill="#d1a11e"
          />
          <ellipse
            cx="179.66"
            cy="191.9"
            rx="3.91"
            ry="12.91"
            transform="translate(-13.92 369.75) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="209.43"
            cy="188.52"
            rx="3.91"
            ry="12.91"
            transform="matrix(0.01, -1, 1, 0.01, 18.95, 396.16)"
            fill="#d1a11e"
          />
          <polygon
            points="222.35 186.69 222.33 188.64 196.52 188.39 196.54 186.44 222.35 186.69"
            fill="#d1a11e"
          />
          <ellipse
            cx="209.45"
            cy="186.56"
            rx="3.91"
            ry="12.91"
            transform="translate(20.93 394.25) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="222.58"
            cy="179.8"
            rx="3.91"
            ry="12.91"
            transform="translate(40.7 400.68) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="235.51 177.97 235.49 179.92 209.68 179.68 209.7 177.72 235.51 177.97"
            fill="#d1a11e"
          />
          <ellipse
            cx="222.6"
            cy="177.85"
            rx="3.91"
            ry="12.91"
            transform="translate(42.67 398.77) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="137.81"
            cy="164.2"
            rx="3.91"
            ry="12.91"
            transform="translate(-27.69 300.46) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="150.73 162.37 150.71 164.33 124.9 164.08 124.92 162.13 150.73 162.37"
            fill="#d1a11e"
          />
          <ellipse
            cx="137.83"
            cy="162.25"
            rx="3.91"
            ry="12.91"
            transform="translate(-25.71 298.55) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="125.03"
            cy="185.64"
            rx="3.91"
            ry="12.91"
            transform="translate(-61.78 308.91) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="137.95 183.81 137.93 185.76 112.12 185.51 112.14 183.56 137.95 183.81"
            fill="#d1a11e"
          />
          <ellipse
            cx="125.05"
            cy="183.68"
            rx="3.91"
            ry="12.91"
            transform="translate(-59.8 307) rotate(-89.46)"
            fill="#e8cd0a"
          />
        </g>
        <g>
          <ellipse
            cx="87.16"
            cy="185.91"
            rx="3.91"
            ry="12.91"
            transform="translate(-99.56 271.32) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="100.09 184.08 100.06 186.03 74.25 185.79 74.28 183.84 100.09 184.08"
            fill="#d1a11e"
          />
          <ellipse
            cx="87.18"
            cy="183.96"
            rx="3.91"
            ry="12.91"
            transform="translate(-97.59 269.41) rotate(-89.46)"
            fill="#e8cd0a"
          />
        </g>
        <g>
          <ellipse
            cx="156.75"
            cy="187.54"
            rx="3.91"
            ry="12.91"
            transform="translate(-32.25 342.52) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="169.68 185.71 169.66 187.66 143.84 187.42 143.87 185.47 169.68 185.71"
            fill="#d1a11e"
          />
          <ellipse
            cx="156.77"
            cy="185.59"
            rx="3.91"
            ry="12.91"
            transform="translate(-30.28 340.61) rotate(-89.46)"
            fill="#e8cd0a"
          />
        </g>
        <g>
          <ellipse
            cx="146.85"
            cy="175.87"
            rx="3.91"
            ry="12.91"
            transform="translate(-30.4 321.06) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="159.78 174.04 159.75 176 133.94 175.75 133.96 173.8 159.78 174.04"
            fill="#d1a11e"
          />
          <ellipse
            cx="146.87"
            cy="173.92"
            rx="3.91"
            ry="12.91"
            transform="translate(-28.42 319.15) rotate(-89.46)"
            fill="#e8cd0a"
          />
        </g>
        <g>
          <ellipse
            cx="145.09"
            cy="161.6"
            rx="3.91"
            ry="12.91"
            transform="translate(-17.86 305.17) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="158.02 159.77 158 161.72 132.19 161.47 132.21 159.52 158.02 159.77"
            fill="#d1a11e"
          />
          <ellipse
            cx="145.11"
            cy="159.64"
            rx="3.91"
            ry="12.91"
            transform="translate(-15.89 303.25) rotate(-89.46)"
            fill="#e8cd0a"
          />
        </g>
        <g>
          <ellipse
            cx="102.53"
            cy="175.87"
            rx="3.91"
            ry="12.91"
            transform="translate(-74.3 276.74) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="115.45 174.04 115.43 176 89.62 175.75 89.64 173.8 115.45 174.04"
            fill="#d1a11e"
          />
          <ellipse
            cx="102.55"
            cy="173.92"
            rx="3.91"
            ry="12.91"
            transform="translate(-72.33 274.83) rotate(-89.46)"
            fill="#e8cd0a"
          />
        </g>
        <g>
          <ellipse
            cx="59.87"
            cy="148.29"
            rx="2.34"
            ry="7.73"
            transform="translate(-88.97 206.76) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="67.61 147.19 67.6 148.36 52.14 148.22 52.15 147.04 67.61 147.19"
            fill="#d1a11e"
          />
          <ellipse
            cx="59.88"
            cy="147.12"
            rx="2.34"
            ry="7.73"
            transform="translate(-87.79 205.62) rotate(-89.46)"
            fill="#e8cd0a"
          />
        </g>
        <g>
          <ellipse
            cx="7.73"
            cy="174.38"
            rx="2.34"
            ry="7.73"
            transform="matrix(0.01, -1, 1, 0.01, -166.72, 180.47)"
            fill="#d1a11e"
          />
          <polygon
            points="15.47 173.29 15.46 174.46 0 174.31 0.01 173.14 15.47 173.29"
            fill="#d1a11e"
          />
          <ellipse
            cx="7.74"
            cy="173.21"
            rx="2.34"
            ry="7.73"
            transform="matrix(0.01, -1, 1, 0.01, -165.53, 179.33)"
            fill="#e8cd0a"
          />
        </g>
        <g>
          <ellipse
            cx="170.24"
            cy="157.87"
            rx="3.91"
            ry="12.91"
            transform="translate(10.78 326.62) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="183.17 156.04 183.15 157.99 157.34 157.75 157.36 155.79 183.17 156.04"
            fill="#d1a11e"
          />
          <ellipse
            cx="170.27"
            cy="155.92"
            rx="3.91"
            ry="12.91"
            transform="translate(12.76 324.71) rotate(-89.46)"
            fill="#e8cd0a"
          />
        </g>
        <g>
          <ellipse
            cx="167.85"
            cy="184.54"
            rx="3.91"
            ry="12.91"
            transform="translate(-18.26 350.65) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="180.78 182.71 180.75 184.66 154.94 184.41 154.97 182.46 180.78 182.71"
            fill="#d1a11e"
          />
          <ellipse
            cx="167.87"
            cy="182.58"
            rx="3.91"
            ry="12.91"
            transform="translate(-16.28 348.73) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="169.29"
            cy="175.87"
            rx="3.91"
            ry="12.91"
            transform="translate(-8.17 343.5) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="182.21 174.04 182.19 176 156.38 175.75 156.4 173.8 182.21 174.04"
            fill="#d1a11e"
          />
          <ellipse
            cx="169.31"
            cy="173.92"
            rx="3.91"
            ry="12.91"
            transform="matrix(0.01, -1, 1, 0.01, -6.19, 341.59)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="195.21"
            cy="176.97"
            rx="3.91"
            ry="12.91"
            transform="translate(16.41 370.51) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="208.13 175.14 208.11 177.09 182.3 176.85 182.32 174.9 208.13 175.14"
            fill="#d1a11e"
          />
          <ellipse
            cx="195.23"
            cy="175.02"
            rx="3.91"
            ry="12.91"
            transform="translate(18.38 368.6) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="186.58"
            cy="178.07"
            rx="3.91"
            ry="12.91"
            transform="translate(6.77 362.97) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="199.51 176.24 199.49 178.19 173.68 177.95 173.7 176 199.51 176.24"
            fill="#d1a11e"
          />
          <ellipse
            cx="186.6"
            cy="176.12"
            rx="3.91"
            ry="12.91"
            transform="translate(8.74 361.06) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="163.82"
            cy="169.94"
            rx="3.91"
            ry="12.91"
            transform="translate(-7.64 332.16) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="176.75 168.11 176.73 170.06 150.92 169.81 150.94 167.86 176.75 168.11"
            fill="#d1a11e"
          />
          <ellipse
            cx="163.85"
            cy="167.98"
            rx="3.91"
            ry="12.91"
            transform="translate(-5.67 330.24) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="160.54"
            cy="244.05"
            rx="3.91"
            ry="12.91"
            transform="translate(-85.01 402.28) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="173.46 242.22 173.44 244.17 147.63 243.92 147.65 241.97 173.46 242.22"
            fill="#d1a11e"
          />
          <ellipse
            cx="160.56"
            cy="242.09"
            rx="3.91"
            ry="12.91"
            transform="translate(-83.03 400.37) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="200.13"
            cy="183.84"
            rx="3.91"
            ry="12.91"
            transform="matrix(0.01, -1, 1, 0.01, 14.42, 382.23)"
            fill="#d1a11e"
          />
          <polygon
            points="213.06 182.01 213.04 183.96 187.22 183.72 187.25 181.76 213.06 182.01"
            fill="#d1a11e"
          />
          <ellipse
            cx="200.15"
            cy="181.89"
            rx="3.91"
            ry="12.91"
            transform="translate(16.4 380.32) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="221.39"
            cy="190.58"
            rx="3.91"
            ry="12.91"
            transform="translate(28.73 410.17) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="234.31 188.75 234.29 190.71 208.48 190.46 208.5 188.5 234.31 188.75"
            fill="#d1a11e"
          />
          <ellipse
            cx="221.41"
            cy="188.63"
            rx="3.91"
            ry="12.91"
            transform="translate(30.71 408.25) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="213.05"
            cy="176.97"
            rx="3.91"
            ry="12.91"
            transform="translate(34.08 388.35) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="225.97 175.14 225.95 177.09 200.14 176.85 200.16 174.9 225.97 175.14"
            fill="#d1a11e"
          />
          <ellipse
            cx="213.07"
            cy="175.02"
            rx="3.91"
            ry="12.91"
            transform="translate(36.06 386.44) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="151.14"
            cy="158.49"
            rx="3.91"
            ry="12.91"
            transform="translate(-8.77 308.13) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="164.06 156.66 164.04 158.61 138.23 158.37 138.25 156.41 164.06 156.66"
            fill="#d1a11e"
          />
          <ellipse
            cx="151.16"
            cy="156.54"
            rx="3.91"
            ry="12.91"
            transform="translate(-6.79 306.22) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="154.38"
            cy="145.15"
            rx="3.91"
            ry="12.91"
            transform="translate(7.79 298.15) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="167.3 143.32 167.28 145.27 141.47 145.02 141.49 143.07 167.3 143.32"
            fill="#d1a11e"
          />
          <ellipse
            cx="154.4"
            cy="143.19"
            rx="3.91"
            ry="12.91"
            transform="translate(9.76 296.24) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="206.4"
            cy="161.6"
            rx="3.91"
            ry="12.91"
            transform="translate(42.87 366.47) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="219.33 159.77 219.31 161.72 193.5 161.47 193.52 159.52 219.33 159.77"
            fill="#d1a11e"
          />
          <ellipse
            cx="206.42"
            cy="159.64"
            rx="3.91"
            ry="12.91"
            transform="translate(44.85 364.56) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="234.3"
            cy="185.51"
            rx="3.91"
            ry="12.91"
            transform="translate(46.6 418.06) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="247.23 183.68 247.21 185.64 221.4 185.39 221.42 183.44 247.23 183.68"
            fill="#d1a11e"
          />
          <ellipse
            cx="234.32"
            cy="183.56"
            rx="3.91"
            ry="12.91"
            transform="translate(48.57 416.15) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="257.79"
            cy="208.76"
            rx="3.91"
            ry="12.91"
            transform="translate(46.63 464.58) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="270.72 206.93 270.7 208.88 244.89 208.63 244.91 206.68 270.72 206.93"
            fill="#d1a11e"
          />
          <ellipse
            cx="257.82"
            cy="206.8"
            rx="3.91"
            ry="12.91"
            transform="translate(48.6 462.67) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="234.18"
            cy="196.65"
            rx="3.91"
            ry="12.91"
            transform="translate(35.34 428.97) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="247.1 194.82 247.08 196.77 221.27 196.52 221.29 194.57 247.1 194.82"
            fill="#d1a11e"
          />
          <ellipse
            cx="234.2"
            cy="194.69"
            rx="3.91"
            ry="12.91"
            transform="translate(37.31 427.05) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="202.04"
            cy="170.31"
            rx="3.91"
            ry="12.91"
            transform="translate(29.85 370.74) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="214.97 168.48 214.95 170.43 189.13 170.18 189.16 168.23 214.97 168.48"
            fill="#d1a11e"
          />
          <ellipse
            cx="202.06"
            cy="168.35"
            rx="3.91"
            ry="12.91"
            transform="translate(31.82 368.83) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="182.09"
            cy="171.99"
            rx="3.91"
            ry="12.91"
            transform="matrix(0.01, -1, 1, 0.01, 8.4, 352.46)"
            fill="#d1a11e"
          />
          <polygon
            points="195.02 170.16 195 172.11 169.19 171.87 169.21 169.91 195.02 170.16"
            fill="#d1a11e"
          />
          <ellipse
            cx="182.11"
            cy="170.04"
            rx="3.91"
            ry="12.91"
            transform="translate(10.37 350.55) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="135.79"
            cy="172"
            rx="3.91"
            ry="12.91"
            transform="translate(-37.47 306.17) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="148.72 170.17 148.7 172.12 122.89 171.88 122.91 169.92 148.72 170.17"
            fill="#d1a11e"
          />
          <ellipse
            cx="135.81"
            cy="170.05"
            rx="3.91"
            ry="12.91"
            transform="translate(-35.5 304.26) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="79.19"
            cy="189.97"
            rx="3.91"
            ry="12.91"
            transform="translate(-111.51 267.37) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="92.11 188.14 92.09 190.09 66.28 189.84 66.3 187.89 92.11 188.14"
            fill="#d1a11e"
          />
          <ellipse
            cx="79.21"
            cy="188.01"
            rx="3.91"
            ry="12.91"
            transform="translate(-109.54 265.45) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="60.54"
            cy="202.69"
            rx="3.91"
            ry="12.91"
            transform="translate(-142.71 261.32) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="73.47 200.86 73.45 202.81 47.64 202.56 47.66 200.61 73.47 200.86"
            fill="#d1a11e"
          />
          <ellipse
            cx="60.56"
            cy="200.74"
            rx="3.91"
            ry="12.91"
            transform="translate(-140.73 259.41) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="54.72"
            cy="213.87"
            rx="3.91"
            ry="12.91"
            transform="translate(-159.65 266.58) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="67.65 212.04 67.63 213.99 41.82 213.75 41.84 211.79 67.65 212.04"
            fill="#d1a11e"
          />
          <ellipse
            cx="54.74"
            cy="211.92"
            rx="3.91"
            ry="12.91"
            transform="translate(-157.68 264.67) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="71.43"
            cy="196.85"
            rx="3.91"
            ry="12.91"
            transform="translate(-126.09 266.43) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="84.36 195.02 84.33 196.97 58.52 196.73 58.54 194.78 84.36 195.02"
            fill="#d1a11e"
          />
          <ellipse
            cx="71.45"
            cy="194.9"
            rx="3.91"
            ry="12.91"
            transform="translate(-124.11 264.51) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="182.2"
            cy="166.11"
            rx="3.91"
            ry="12.91"
            transform="translate(14.39 346.74) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="195.13 164.28 195.11 166.23 169.3 165.99 169.32 164.03 195.13 164.28"
            fill="#d1a11e"
          />
          <ellipse
            cx="182.22"
            cy="164.16"
            rx="3.91"
            ry="12.91"
            transform="translate(16.36 344.83) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="186.52"
            cy="151.53"
            rx="3.91"
            ry="12.91"
            transform="matrix(0.01, -1, 1, 0.01, 33.25, 336.61)"
            fill="#d1a11e"
          />
          <polygon
            points="199.45 149.7 199.42 151.65 173.61 151.41 173.63 149.45 199.45 149.7"
            fill="#d1a11e"
          />
          <ellipse
            cx="186.54"
            cy="149.58"
            rx="3.91"
            ry="12.91"
            transform="translate(35.22 334.7) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="118.55"
            cy="162.32"
            rx="3.91"
            ry="12.91"
            transform="translate(-44.88 279.34) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="131.48 160.5 131.45 162.45 105.64 162.2 105.66 160.25 131.48 160.5"
            fill="#d1a11e"
          />
          <ellipse
            cx="118.57"
            cy="160.37"
            rx="3.91"
            ry="12.91"
            transform="translate(-42.91 277.43) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="146.86"
            cy="142.52"
            rx="3.91"
            ry="12.91"
            transform="translate(2.97 288.03) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="159.79 140.69 159.76 142.64 133.95 142.4 133.97 140.44 159.79 140.69"
            fill="#d1a11e"
          />
          <ellipse
            cx="146.88"
            cy="140.57"
            rx="3.91"
            ry="12.91"
            transform="matrix(0.01, -1, 1, 0.01, 4.94, 286.12)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="138.92"
            cy="150.07"
            rx="3.91"
            ry="12.91"
            transform="translate(-12.45 287.58) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="151.85 148.25 151.83 150.2 126.02 149.95 126.04 148 151.85 148.25"
            fill="#d1a11e"
          />
          <ellipse
            cx="138.94"
            cy="148.12"
            rx="3.91"
            ry="12.91"
            transform="matrix(0.01, -1, 1, 0.01, -10.48, 285.67)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="165.32"
            cy="150.07"
            rx="3.91"
            ry="12.91"
            transform="translate(13.7 313.98) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="178.25 148.25 178.23 150.2 152.41 149.95 152.44 148 178.25 148.25"
            fill="#d1a11e"
          />
          <ellipse
            cx="165.34"
            cy="148.12"
            rx="3.91"
            ry="12.91"
            transform="translate(15.67 312.07) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="150.92"
            cy="165.3"
            rx="3.91"
            ry="12.91"
            transform="translate(-15.8 314.66) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="163.84 163.47 163.82 165.43 138.01 165.18 138.03 163.23 163.84 163.47"
            fill="#d1a11e"
          />
          <ellipse
            cx="150.94"
            cy="163.35"
            rx="3.91"
            ry="12.91"
            transform="translate(-13.82 312.75) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="176.74"
            cy="126.59"
            rx="3.91"
            ry="12.91"
            transform="matrix(0.01, -1, 1, 0.01, 48.49, 302.14)"
            fill="#d1a11e"
          />
          <polygon
            points="189.67 124.76 189.65 126.72 163.83 126.47 163.86 124.52 189.67 124.76"
            fill="#d1a11e"
          />
          <ellipse
            cx="176.76"
            cy="124.64"
            rx="3.91"
            ry="12.91"
            transform="translate(50.47 300.22) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="219.32"
            cy="164.25"
            rx="3.91"
            ry="12.91"
            transform="matrix(0.01, -1, 1, 0.01, 53.02, 382.01)"
            fill="#d1a11e"
          />
          <polygon
            points="232.25 162.42 232.22 164.37 206.41 164.12 206.43 162.17 232.25 162.42"
            fill="#d1a11e"
          />
          <ellipse
            cx="219.34"
            cy="162.29"
            rx="3.91"
            ry="12.91"
            transform="translate(54.99 380.1) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="250.69"
            cy="194.73"
            rx="3.91"
            ry="12.91"
            transform="translate(53.62 443.57) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="263.61 192.9 263.59 194.85 237.78 194.6 237.8 192.65 263.61 192.9"
            fill="#d1a11e"
          />
          <ellipse
            cx="250.71"
            cy="192.77"
            rx="3.91"
            ry="12.91"
            transform="translate(55.59 441.66) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="199.17"
            cy="143.99"
            rx="3.91"
            ry="12.91"
            transform="matrix(0.01, -1, 1, 0.01, 53.32, 341.8)"
            fill="#d1a11e"
          />
          <polygon
            points="212.1 142.16 212.08 144.11 186.26 143.86 186.29 141.91 212.1 142.16"
            fill="#d1a11e"
          />
          <ellipse
            cx="199.19"
            cy="142.03"
            rx="3.91"
            ry="12.91"
            transform="translate(55.29 339.88) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="208.99"
            cy="152.72"
            rx="3.91"
            ry="12.91"
            transform="translate(54.32 360.27) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="221.92 150.89 221.9 152.84 196.09 152.59 196.11 150.64 221.92 150.89"
            fill="#d1a11e"
          />
          <ellipse
            cx="209.02"
            cy="150.76"
            rx="3.91"
            ry="12.91"
            transform="translate(56.3 358.35) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="223.99"
            cy="172.72"
            rx="3.91"
            ry="12.91"
            transform="translate(49.18 395.08) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="236.92 170.89 236.9 172.84 211.09 172.59 211.11 170.64 236.92 170.89"
            fill="#d1a11e"
          />
          <ellipse
            cx="224.01"
            cy="170.76"
            rx="3.91"
            ry="12.91"
            transform="translate(51.15 393.16) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="192.31"
            cy="138.07"
            rx="3.91"
            ry="12.91"
            transform="matrix(0.01, -1, 1, 0.01, 52.44, 329.08)"
            fill="#d1a11e"
          />
          <polygon
            points="205.24 136.24 205.22 138.19 179.41 137.95 179.43 135.99 205.24 136.24"
            fill="#d1a11e"
          />
          <ellipse
            cx="192.33"
            cy="136.12"
            rx="3.91"
            ry="12.91"
            transform="translate(54.42 327.16) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="169.29"
            cy="133.6"
            rx="3.91"
            ry="12.91"
            transform="translate(34.1 301.62) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="182.21 131.77 182.19 133.72 156.38 133.47 156.4 131.52 182.21 131.77"
            fill="#d1a11e"
          />
          <ellipse
            cx="169.31"
            cy="131.64"
            rx="3.91"
            ry="12.91"
            transform="matrix(0.01, -1, 1, 0.01, 36.08, 299.71)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="161.38"
            cy="137.09"
            rx="3.91"
            ry="12.91"
            transform="translate(22.78 297.18) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="174.31 135.26 174.29 137.22 148.47 136.97 148.5 135.02 174.31 135.26"
            fill="#d1a11e"
          />
          <ellipse
            cx="161.4"
            cy="135.14"
            rx="3.91"
            ry="12.91"
            transform="translate(24.75 295.27) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="125.01"
            cy="154.77"
            rx="3.91"
            ry="12.91"
            transform="translate(-30.92 278.33) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="137.94 152.94 137.92 154.9 112.11 154.65 112.13 152.7 137.94 152.94"
            fill="#d1a11e"
          />
          <ellipse
            cx="125.04"
            cy="152.82"
            rx="3.91"
            ry="12.91"
            transform="translate(-28.95 276.42) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="140.52"
            cy="156.89"
            rx="3.91"
            ry="12.91"
            transform="translate(-17.69 295.93) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="153.44 155.06 153.42 157.02 127.61 156.77 127.63 154.82 153.44 155.06"
            fill="#d1a11e"
          />
          <ellipse
            cx="140.54"
            cy="154.94"
            rx="3.91"
            ry="12.91"
            transform="translate(-15.71 294.02) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="189.12"
            cy="157.87"
            rx="3.91"
            ry="12.91"
            transform="translate(29.49 345.5) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="202.05 156.04 202.03 157.99 176.22 157.75 176.24 155.79 202.05 156.04"
            fill="#d1a11e"
          />
          <ellipse
            cx="189.15"
            cy="155.92"
            rx="3.91"
            ry="12.91"
            transform="translate(31.46 343.59) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="241.86"
            cy="211.82"
            rx="3.91"
            ry="12.91"
            transform="translate(27.78 451.68) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="254.79 209.99 254.77 211.94 228.96 211.69 228.98 209.74 254.79 209.99"
            fill="#d1a11e"
          />
          <ellipse
            cx="241.88"
            cy="209.86"
            rx="3.91"
            ry="12.91"
            transform="translate(29.76 449.77) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="238.94"
            cy="226.56"
            rx="3.91"
            ry="12.91"
            transform="translate(10.14 463.36) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="251.86 224.73 251.84 226.68 226.03 226.44 226.05 224.48 251.86 224.73"
            fill="#d1a11e"
          />
          <ellipse
            cx="238.96"
            cy="224.61"
            rx="3.91"
            ry="12.91"
            transform="translate(12.12 461.44) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="57.85"
            cy="231.07"
            rx="3.91"
            ry="12.91"
            transform="matrix(0.01, -1, 1, 0.01, -173.75, 286.74)"
            fill="#d1a11e"
          />
          <polygon
            points="70.78 229.24 70.76 231.19 44.95 230.94 44.97 228.99 70.78 229.24"
            fill="#d1a11e"
          />
          <ellipse
            cx="57.87"
            cy="229.11"
            rx="3.91"
            ry="12.91"
            transform="translate(-171.77 284.83) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="62.07"
            cy="240.59"
            rx="3.91"
            ry="12.91"
            transform="translate(-179.09 300.4) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="75 238.76 74.98 240.71 49.17 240.46 49.19 238.51 75 238.76"
            fill="#d1a11e"
          />
          <ellipse
            cx="62.09"
            cy="238.63"
            rx="3.91"
            ry="12.91"
            transform="translate(-177.11 298.48) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="118.57"
            cy="251.13"
            rx="3.91"
            ry="12.91"
            transform="translate(-133.66 367.34) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="131.5 249.3 131.48 251.25 105.66 251.01 105.69 249.06 131.5 249.3"
            fill="#d1a11e"
          />
          <ellipse
            cx="118.59"
            cy="249.18"
            rx="3.91"
            ry="12.91"
            transform="translate(-131.69 365.42) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="146.12"
            cy="253.44"
            rx="3.91"
            ry="12.91"
            transform="translate(-108.69 397.17) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="159.04 251.61 159.02 253.56 133.21 253.32 133.23 251.37 159.04 251.61"
            fill="#d1a11e"
          />
          <ellipse
            cx="146.14"
            cy="251.49"
            rx="3.91"
            ry="12.91"
            transform="translate(-106.71 395.26) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="171.95"
            cy="232.14"
            rx="3.91"
            ry="12.91"
            transform="translate(-61.79 401.9) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="184.88 230.31 184.86 232.26 159.04 232.01 159.07 230.06 184.88 230.31"
            fill="#d1a11e"
          />
          <ellipse
            cx="171.97"
            cy="230.18"
            rx="3.91"
            ry="12.91"
            transform="translate(-59.82 399.99) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="318.01"
            cy="305.61"
            rx="3.91"
            ry="12.91"
            transform="matrix(0.01, -1, 1, 0.01, 9.43, 620.73)"
            fill="#d1a11e"
          />
          <polygon
            points="330.94 303.78 330.92 305.73 305.1 305.48 305.13 303.53 330.94 303.78"
            fill="#d1a11e"
          />
          <ellipse
            cx="318.03"
            cy="303.65"
            rx="3.91"
            ry="12.91"
            transform="translate(11.4 618.82) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="196.52"
            cy="258.22"
            rx="3.91"
            ry="12.91"
            transform="translate(-63.53 452.3) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="209.45 256.39 209.43 258.34 183.62 258.09 183.64 256.14 209.45 256.39"
            fill="#d1a11e"
          />
          <ellipse
            cx="196.54"
            cy="256.26"
            rx="3.91"
            ry="12.91"
            transform="translate(-61.55 450.39) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="242.77"
            cy="259.63"
            rx="3.91"
            ry="12.91"
            transform="matrix(0.01, -1, 1, 0.01, -19.12, 499.95)"
            fill="#d1a11e"
          />
          <polygon
            points="255.7 257.8 255.68 259.75 229.87 259.5 229.89 257.55 255.7 257.8"
            fill="#d1a11e"
          />
          <ellipse
            cx="242.79"
            cy="257.67"
            rx="3.91"
            ry="12.91"
            transform="translate(-17.15 498.04) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="284.9"
            cy="257.24"
            rx="3.91"
            ry="12.91"
            transform="matrix(0.01, -1, 1, 0.01, 25, 539.71)"
            fill="#d1a11e"
          />
          <polygon
            points="297.83 255.41 297.81 257.36 272 257.12 272.02 255.16 297.83 255.41"
            fill="#d1a11e"
          />
          <ellipse
            cx="284.92"
            cy="255.29"
            rx="3.91"
            ry="12.91"
            transform="translate(26.97 537.8) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="276.85"
            cy="238.26"
            rx="3.91"
            ry="12.91"
            transform="translate(36.01 512.86) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="289.78 236.43 289.76 238.38 263.95 238.13 263.97 236.18 289.78 236.43"
            fill="#d1a11e"
          />
          <ellipse
            cx="276.87"
            cy="236.3"
            rx="3.91"
            ry="12.91"
            transform="translate(37.98 510.95) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="254.78"
            cy="219.31"
            rx="3.91"
            ry="12.91"
            transform="translate(33.08 472.02) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="267.71 217.48 267.68 219.44 241.87 219.19 241.89 217.24 267.71 217.48"
            fill="#d1a11e"
          />
          <ellipse
            cx="254.8"
            cy="217.36"
            rx="3.91"
            ry="12.91"
            transform="translate(35.06 470.11) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="251.69"
            cy="231.91"
            rx="3.91"
            ry="12.91"
            transform="matrix(0.01, -1, 1, 0.01, 17.43, 481.41)"
            fill="#d1a11e"
          />
          <polygon
            points="264.62 230.08 264.6 232.03 238.79 231.79 238.81 229.83 264.62 230.08"
            fill="#d1a11e"
          />
          <ellipse
            cx="251.71"
            cy="229.96"
            rx="3.91"
            ry="12.91"
            transform="translate(19.4 479.5) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="236.64"
            cy="204.85"
            rx="3.91"
            ry="12.91"
            transform="translate(29.57 439.55) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="249.56 203.02 249.54 204.97 223.73 204.72 223.75 202.77 249.56 203.02"
            fill="#d1a11e"
          />
          <ellipse
            cx="236.66"
            cy="202.9"
            rx="3.91"
            ry="12.91"
            transform="translate(31.55 437.64) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="47.63"
            cy="223.58"
            rx="3.91"
            ry="12.91"
            transform="translate(-176.39 269.1) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="60.55 221.75 60.53 223.7 34.72 223.46 34.74 221.5 60.55 221.75"
            fill="#d1a11e"
          />
          <ellipse
            cx="47.65"
            cy="221.63"
            rx="3.91"
            ry="12.91"
            transform="translate(-174.42 267.19) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="18.44"
            cy="226.75"
            rx="3.91"
            ry="12.91"
            transform="matrix(0.01, -1, 1, 0.01, -208.48, 243.06)"
            fill="#d1a11e"
          />
          <polygon
            points="31.37 224.93 31.35 226.88 5.53 226.63 5.56 224.68 31.37 224.93"
            fill="#d1a11e"
          />
          <ellipse
            cx="18.46"
            cy="224.8"
            rx="3.91"
            ry="12.91"
            transform="translate(-206.5 241.15) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="29.89"
            cy="251.13"
            rx="3.91"
            ry="12.91"
            transform="translate(-221.51 278.66) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="42.82 249.3 42.8 251.25 16.98 251.01 17 249.06 42.82 249.3"
            fill="#d1a11e"
          />
          <ellipse
            cx="29.91"
            cy="249.18"
            rx="3.91"
            ry="12.91"
            transform="translate(-219.54 276.75) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="80.05"
            cy="257.12"
            rx="3.91"
            ry="12.91"
            transform="translate(-177.8 334.75) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="92.98 255.29 92.96 257.24 67.15 256.99 67.17 255.04 92.98 255.29"
            fill="#d1a11e"
          />
          <ellipse
            cx="80.07"
            cy="255.16"
            rx="3.91"
            ry="12.91"
            transform="matrix(0.01, -1, 1, 0.01, -175.83, 332.84)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="67.65"
            cy="211.15"
            rx="3.91"
            ry="12.91"
            transform="translate(-144.13 276.82) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="80.58 209.32 80.56 211.28 54.74 211.03 54.77 209.08 80.58 209.32"
            fill="#d1a11e"
          />
          <ellipse
            cx="67.67"
            cy="209.2"
            rx="3.91"
            ry="12.91"
            transform="translate(-142.15 274.9) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="86.85"
            cy="218.76"
            rx="3.91"
            ry="12.91"
            transform="translate(-132.72 303.56) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="99.78 216.93 99.76 218.89 73.95 218.64 73.97 216.69 99.78 216.93"
            fill="#d1a11e"
          />
          <ellipse
            cx="86.87"
            cy="216.81"
            rx="3.91"
            ry="12.91"
            transform="translate(-130.74 301.64) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <ellipse
            cx="74.99"
            cy="230.25"
            rx="3.91"
            ry="12.91"
            transform="translate(-155.95 303.07) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="87.92 228.42 87.9 230.37 62.08 230.13 62.11 228.17 87.92 228.42"
            fill="#d1a11e"
          />
          <ellipse
            cx="75.01"
            cy="228.3"
            rx="3.91"
            ry="12.91"
            transform="translate(-153.98 301.16) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
        <g>
          <polygon
            points="140.08 222.27 139.42 230.34 127.82 235.43 133.05 223.51 140.08 222.27"
            fill="#e20c49"
          />
          <polyline
            points="135.84 230.13 138.07 229.09 138.33 224.4"
            fill="none"
            stroke="#f2e2e8"
            strokeMiterlimit="10"
            strokeWidth="0.68"
          />
        </g>
        <g>
          <polygon
            points="231.15 232.18 238.31 235.94 238.46 248.61 229.54 239.14 231.15 232.18"
            fill="#e20c49"
          />
          <polyline
            points="236.72 239.16 236.63 236.69 232.42 234.62"
            fill="none"
            stroke="#f2e2e8"
            strokeMiterlimit="10"
            strokeWidth="0.68"
          />
        </g>
        <g>
          <polygon
            points="57 224.27 70.38 224.76 79.68 243.55 59.59 235.81 57 224.27"
            fill="#e20c49"
          />
          <polyline
            points="70.32 230.69 68.42 227.08 60.66 227"
            fill="none"
            stroke="#f2e2e8"
            strokeMiterlimit="10"
            strokeWidth="1.12"
          />
        </g>
        <g>
          <polygon
            points="135.8 251.31 124.44 258.96 106.42 249.37 127.32 243.55 135.8 251.31"
            fill="#1ee00e"
          />
          <polyline
            points="121.24 254.13 124.8 255.91 131.27 251.3"
            fill="none"
            stroke="#f2e2e8"
            strokeMiterlimit="10"
            strokeWidth="1.12"
          />
        </g>
        <g>
          <polygon
            points="281.77 231.82 270.42 239.47 252.39 229.88 273.29 224.06 281.77 231.82"
            fill="#1ee00e"
          />
          <polyline
            points="267.21 234.64 270.77 236.42 277.24 231.81"
            fill="none"
            stroke="#f2e2e8"
            strokeMiterlimit="10"
            strokeWidth="1.12"
          />
        </g>
        <g>
          <ellipse
            cx="186.51"
            cy="185.76"
            rx="3.91"
            ry="12.91"
            transform="matrix(0.01, -1, 1, 0.01, -0.99, 370.51)"
            fill="#d1a11e"
          />
          <polygon
            points="199.44 183.93 199.41 185.88 173.6 185.63 173.62 183.68 199.44 183.93"
            fill="#d1a11e"
          />
          <ellipse
            cx="186.53"
            cy="183.81"
            rx="3.91"
            ry="12.91"
            transform="translate(0.98 368.6) rotate(-89.46)"
            fill="#e8cd0a"
          />
        </g>
        <g>
          <ellipse
            cx="184.26"
            cy="205"
            rx="3.03"
            ry="10"
            transform="translate(-22.46 387.33) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="194.28 203.58 194.26 205.09 174.26 204.9 174.28 203.39 194.28 203.58"
            fill="#d1a11e"
          />
          <ellipse
            cx="184.28"
            cy="203.49"
            rx="3.03"
            ry="10"
            transform="translate(-20.93 385.85) rotate(-89.46)"
            fill="#e8cd0a"
          />
        </g>
        <g>
          <ellipse
            cx="209.84"
            cy="194.39"
            rx="3.03"
            ry="10"
            transform="translate(13.48 402.39) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="219.85 192.97 219.84 194.49 199.84 194.3 199.85 192.78 219.85 192.97"
            fill="#d1a11e"
          />
          <ellipse
            cx="209.85"
            cy="192.88"
            rx="3.03"
            ry="10"
            transform="translate(15.01 400.91) rotate(-89.46)"
            fill="#e8cd0a"
          />
        </g>
        <g>
          <ellipse
            cx="233.98"
            cy="217.46"
            rx="3.03"
            ry="10"
            transform="translate(14.34 449.39) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="244 216.04 243.98 217.55 223.98 217.36 224 215.85 244 216.04"
            fill="#d1a11e"
          />
          <ellipse
            cx="234"
            cy="215.94"
            rx="3.03"
            ry="10"
            transform="translate(15.87 447.91) rotate(-89.46)"
            fill="#e8cd0a"
          />
        </g>
        <g>
          <ellipse
            cx="121.23"
            cy="203.32"
            rx="3.03"
            ry="10"
            transform="translate(-83.22 322.64) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="131.25 201.9 131.23 203.42 111.23 203.22 111.25 201.71 131.25 201.9"
            fill="#d1a11e"
          />
          <ellipse
            cx="121.25"
            cy="201.81"
            rx="3.03"
            ry="10"
            transform="translate(-81.69 321.16) rotate(-89.46)"
            fill="#e8cd0a"
          />
        </g>
        <g>
          <ellipse
            cx="150.53"
            cy="222.46"
            rx="3.03"
            ry="10"
            transform="translate(-73.34 370.9) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="160.55 221.04 160.53 222.56 140.53 222.37 140.55 220.85 160.55 221.04"
            fill="#d1a11e"
          />
          <ellipse
            cx="150.55"
            cy="220.95"
            rx="3.03"
            ry="10"
            transform="translate(-71.81 369.41) rotate(-89.46)"
            fill="#e8cd0a"
          />
        </g>
        <g>
          <ellipse
            cx="155.1"
            cy="241.34"
            rx="3.03"
            ry="10"
            transform="translate(-87.68 394.17) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="165.12 239.93 165.1 241.44 145.1 241.25 145.12 239.73 165.12 239.93"
            fill="#d1a11e"
          />
          <ellipse
            cx="155.12"
            cy="239.83"
            rx="3.03"
            ry="10"
            transform="translate(-86.15 392.69) rotate(-89.46)"
            fill="#e8cd0a"
          />
        </g>
        <g>
          <ellipse
            cx="226.4"
            cy="226.54"
            rx="3.03"
            ry="10"
            transform="translate(-2.25 450.8) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="236.42 225.12 236.41 226.63 216.4 226.44 216.42 224.93 236.42 225.12"
            fill="#d1a11e"
          />
          <ellipse
            cx="226.42"
            cy="225.02"
            rx="3.03"
            ry="10"
            transform="translate(-0.72 449.32) rotate(-89.46)"
            fill="#e8cd0a"
          />
        </g>
        <g>
          <ellipse
            cx="222.36"
            cy="203.51"
            rx="3.03"
            ry="10"
            transform="translate(16.76 423.95) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="232.38 202.1 232.36 203.61 212.36 203.42 212.37 201.91 232.38 202.1"
            fill="#d1a11e"
          />
          <ellipse
            cx="222.37"
            cy="202"
            rx="3.03"
            ry="10"
            transform="translate(18.29 422.47) rotate(-89.46)"
            fill="#e8cd0a"
          />
        </g>
        <g>
          <ellipse
            cx="96.5"
            cy="199.6"
            rx="3.91"
            ry="12.91"
            transform="translate(-104 294.22) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="109.43 197.78 109.4 199.73 83.59 199.48 83.61 197.53 109.43 197.78"
            fill="#d1a11e"
          />
          <ellipse
            cx="96.52"
            cy="197.65"
            rx="3.91"
            ry="12.91"
            transform="translate(-102.03 292.31) rotate(-89.46)"
            fill="#e8cd0a"
          />
        </g>
        <g>
          <ellipse
            cx="197.56"
            cy="166.11"
            rx="3.91"
            ry="12.91"
            transform="translate(29.61 362.11) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="210.49 164.28 210.47 166.23 184.66 165.99 184.68 164.03 210.49 164.28"
            fill="#d1a11e"
          />
          <ellipse
            cx="197.59"
            cy="164.16"
            rx="3.91"
            ry="12.91"
            transform="translate(31.58 360.19) rotate(-89.46)"
            fill="#e8cd0a"
          />
        </g>
        <g>
          <ellipse
            cx="152.03"
            cy="152.17"
            rx="2.34"
            ry="7.73"
            transform="translate(-1.56 302.77) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="159.77 151.07 159.76 152.25 144.3 152.1 144.31 150.93 159.77 151.07"
            fill="#d1a11e"
          />
          <ellipse
            cx="152.04"
            cy="151"
            rx="2.34"
            ry="7.73"
            transform="translate(-0.38 301.62) rotate(-89.46)"
            fill="#e8cd0a"
          />
        </g>
        <g>
          <ellipse
            cx="125.92"
            cy="152.11"
            rx="2.34"
            ry="7.73"
            transform="translate(-27.37 276.6) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="133.66 151.02 133.65 152.19 118.19 152.04 118.2 150.87 133.66 151.02"
            fill="#d1a11e"
          />
          <ellipse
            cx="125.93"
            cy="150.94"
            rx="2.34"
            ry="7.73"
            transform="matrix(0.01, -1, 1, 0.01, -26.19, 275.45)"
            fill="#e8cd0a"
          />
        </g>
        <g>
          <ellipse
            cx="190.98"
            cy="150.28"
            rx="2.34"
            ry="7.73"
            transform="translate(38.91 339.84) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="198.72 149.19 198.71 150.36 183.25 150.21 183.26 149.04 198.72 149.19"
            fill="#d1a11e"
          />
          <ellipse
            cx="190.99"
            cy="149.11"
            rx="2.34"
            ry="7.73"
            transform="translate(40.09 338.7) rotate(-89.46)"
            fill="#e8cd0a"
          />
        </g>
        <g>
          <ellipse
            cx="128.31"
            cy="167.72"
            rx="2.34"
            ry="7.73"
            transform="translate(-40.6 294.45) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="136.06 166.62 136.04 167.79 120.58 167.64 120.6 166.47 136.06 166.62"
            fill="#d1a11e"
          />
          <ellipse
            cx="128.33"
            cy="166.55"
            rx="2.34"
            ry="7.73"
            transform="translate(-39.42 293.3) rotate(-89.46)"
            fill="#e8cd0a"
          />
        </g>
        <g>
          <ellipse
            cx="174.91"
            cy="144.17"
            rx="3.91"
            ry="12.91"
            transform="translate(29.11 317.72) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="187.84 142.34 187.82 144.29 162.01 144.05 162.03 142.09 187.84 142.34"
            fill="#d1a11e"
          />
          <ellipse
            cx="174.94"
            cy="142.22"
            rx="3.91"
            ry="12.91"
            transform="translate(31.08 315.81) rotate(-89.46)"
            fill="#e8cd0a"
          />
        </g>
        <g>
          <ellipse
            cx="162"
            cy="127.69"
            rx="3.91"
            ry="12.91"
            transform="translate(32.79 288.48) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="174.93 125.86 174.9 127.82 149.09 127.57 149.11 125.62 174.93 125.86"
            fill="#d1a11e"
          />
          <ellipse
            cx="162.02"
            cy="125.74"
            rx="3.91"
            ry="12.91"
            transform="translate(34.76 286.57) rotate(-89.46)"
            fill="#e8cd0a"
          />
        </g>
        <g>
          <ellipse
            cx="183.82"
            cy="135.95"
            rx="3.91"
            ry="12.91"
            transform="translate(46.15 318.48) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="196.75 134.12 196.72 136.07 170.91 135.82 170.93 133.87 196.75 134.12"
            fill="#d1a11e"
          />
          <ellipse
            cx="183.84"
            cy="133.99"
            rx="3.91"
            ry="12.91"
            transform="translate(48.13 316.57) rotate(-89.46)"
            fill="#e8cd0a"
          />
        </g>
        <g>
          <ellipse
            cx="170.25"
            cy="166.11"
            rx="3.91"
            ry="12.91"
            transform="translate(2.55 334.8) rotate(-89.46)"
            fill="#d1a11e"
          />
          <polygon
            points="183.18 164.28 183.16 166.23 157.35 165.99 157.37 164.03 183.18 164.28"
            fill="#d1a11e"
          />
          <ellipse
            cx="170.28"
            cy="164.16"
            rx="3.91"
            ry="12.91"
            transform="translate(4.53 332.88) rotate(-89.46)"
            fill="#eaa907"
          />
        </g>
      </g>
    </g>
  );
};

export default Decor1;
